import * as i0 from '@angular/core';
import { Directive, Input, HostListener, Injectable, Component, EventEmitter, ViewChild, Output, NgModule, Inject } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { __rest } from 'tslib';
import Swal from 'sweetalert2';
import * as i1$2 from '@angular/common/http';
import { HttpParams, HttpClient } from '@angular/common/http';
export { HttpClient } from '@angular/common/http';
import * as i2 from '@angular/platform-browser';
import * as i3 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i5$1 from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import * as i3$1 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import 'reflect-metadata';
import { tap } from 'rxjs/operators';

class DeletarDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        const el = this.elRef.nativeElement;
        this.subscription = fromEvent(el.parentNode, 'click', { capture: true }).subscribe((e) => {
            if (e.target === el) {
                e.stopPropagation();
                window.dispatchEvent(new CustomEvent('deletar-insert-edit-event'));
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
DeletarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DeletarDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DeletarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: DeletarDirective, selector: "button[crud-deletar] , span[crud-deletar] , icon[crud-deletar] , mat-icon[crud-deletar]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DeletarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-deletar] , span[crud-deletar] , icon[crud-deletar] , mat-icon[crud-deletar]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class AdicionarDirective {
    constructor(elRef, location, route, router) {
        this.elRef = elRef;
        this.location = location;
        this.route = route;
        this.router = router;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        const el = this.elRef.nativeElement;
        this.subscription = fromEvent(el.parentNode, 'click', { capture: true }).subscribe((e) => {
            if (e.target === el) {
                e.stopPropagation();
                this.location.go(window.location.pathname + '/novo');
                window.location.reload();
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
AdicionarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AdicionarDirective, deps: [{ token: i0.ElementRef }, { token: i1.Location }, { token: i1$1.ActivatedRoute }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Directive });
AdicionarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: AdicionarDirective, selector: "button[crud-adicionar] , span[crud-adicionar]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AdicionarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-adicionar] , span[crud-adicionar]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.Location }, { type: i1$1.ActivatedRoute }, { type: i1$1.Router }]; } });

class VoltarDirective {
    constructor(elRef, location) {
        this.elRef = elRef;
        this.location = location;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        const el = this.elRef.nativeElement;
        this.subscription = fromEvent(el.parentNode, 'click', { capture: true }).subscribe((e) => {
            if (e.target === el) {
                e.stopPropagation();
                // window.dispatchEvent(new CustomEvent('voltar-insert-edit-event'));
                this.location.back();
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
VoltarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VoltarDirective, deps: [{ token: i0.ElementRef }, { token: i1.Location }], target: i0.ɵɵFactoryTarget.Directive });
VoltarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: VoltarDirective, selector: "button[crud-voltar] , span[crud-voltar]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: VoltarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-voltar] , span[crud-voltar]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.Location }]; } });

class SalvarDirective {
    constructor() {
        this.endpoint = undefined;
        this.backAfterSave = undefined;
    }
    click() {
        let paramSave = {
            endPoint: false,
            backAfterSave: undefined
        };
        if (this.endpoint) {
            paramSave.endPoint = this.endpoint;
        }
        if (typeof this.backAfterSave === "boolean") {
            paramSave.backAfterSave = this.backAfterSave;
        }
        window.dispatchEvent(new CustomEvent('salvar-insert-edit-event', {
            detail: paramSave
        }));
    }
}
SalvarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SalvarDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
SalvarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: SalvarDirective, selector: "button[crud-salvar] , span[crud-salvar]", inputs: { endpoint: "endpoint", backAfterSave: "backAfterSave" }, host: { listeners: { "click": "click()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: SalvarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-salvar] , span[crud-salvar]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { endpoint: [{
                type: Input,
                args: ['endpoint']
            }], backAfterSave: [{
                type: Input,
                args: ['backAfterSave']
            }], click: [{
                type: HostListener,
                args: ['click']
            }] } });

function tableEventKey(currentTableEventId, data) {
    var _a;
    if (!!data) {
        if (typeof data == "string") {
            return data;
        }
        if (data instanceof CustomEvent) {
            if (!!((_a = data.detail) === null || _a === void 0 ? void 0 : _a.tableEventId)) {
                return data.detail.tableEventId;
            }
            else if (typeof data.detail == 'string') {
                return data.detail;
            }
            else if (!(document.getElementsByClassName('generic-crudTable-key').length > 1)) {
                return String(currentTableEventId);
            }
            else {
                throw currentTableEventId + ' - Um evento foi disparado para a tabela dg-crud e o identificados de eventos não' +
                    ' foi informado. Por existir mais de uma tabela nesta tela, a dg-crud não sabe em qual tabela deve aplicar' +
                    ' o evento';
            }
        }
        if (data instanceof Object) {
            if ('tableEventId' in data) {
                return data.tableEventId;
            }
        }
    }
    else if (!(document.getElementsByClassName('generic-crudTable-key').length > 1)) {
        return currentTableEventId;
    }
    throw currentTableEventId + ' - Um evento foi disparado para a tabela dg-crud e o identificados de eventos não' +
        ' foi informado. Por existir mais de uma tabela nesta tela, a dg-crud não sabe em qual tabela deve aplicar' +
        ' o evento';
}

class CrudTableInitializeService {
    constructor(crudTable) {
        this.crudTable = crudTable;
    }
    initialize() {
        // if (!!this.crudTable.columns) {
        //   this.initializeByInputColumns();
        // } else {
        this.initializeByEntity();
        // }
    }
    initializeByInputColumns() {
    }
    initializeByEntity() {
        var _a;
        (_a = this.crudTable.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.forEach((value, key) => {
            let column = {
                header: value.columnName,
                varName: key,
            };
            if (!!value.resource)
                column.resource = value.resource;
            if (!!value.mask)
                column.mask = value.mask;
            if (!!value.width)
                column.width = value.width;
            if (value.declaratResourceMethod)
                column.declaratResourceMethod = value.declaratResourceMethod;
            if (value.fixedColumnEnd)
                column.fixedColumnEnd = value.fixedColumnEnd;
            if (value.fixedColumnStart)
                column.fixedColumnStart = value.fixedColumnStart;
            if (value.sort)
                column.sort = value.sort;
            column.columnClassName = value.columnClassName;
            this.crudTable.tableColumns.push(column);
        });
    }
    resolveServiceParams() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const endpoint = {
            path: '',
            context: '',
            method: 'GET'
        };
        if ((_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.dataServer) {
            if (!!((_b = this.crudTable.entityMap.dataServer) === null || _b === void 0 ? void 0 : _b.path))
                endpoint['path'] = this.crudTable.entityMap.dataServer.path;
            if (!!((_c = this.crudTable.entityMap.dataServer) === null || _c === void 0 ? void 0 : _c.context))
                endpoint['context'] = this.crudTable.entityMap.dataServer.context;
            if (!!((_d = this.crudTable.entityMap.dataServer) === null || _d === void 0 ? void 0 : _d.endpoint))
                endpoint['endpoint'] = this.crudTable.entityMap.dataServer.endpoint;
            if (!!((_e = this.crudTable.entityMap.dataServer) === null || _e === void 0 ? void 0 : _e.headers))
                endpoint['headers'] = this.crudTable.entityMap.dataServer.headers;
            if (!!((_f = this.crudTable.entityMap.dataServer) === null || _f === void 0 ? void 0 : _f.params))
                endpoint['params'] = Object.assign(Object.assign({}, endpoint['params']), this.crudTable.entityMap.dataServer.params);
        }
        if (!!this.crudTable.service) {
            if (!!this.crudTable.service.path)
                endpoint['path'] = this.crudTable.service._path;
            if (!!this.crudTable.service.context)
                endpoint['context'] = this.crudTable.service.context;
        }
        if (!!this.crudTable.server) {
            if (!!((_g = this.crudTable.server) === null || _g === void 0 ? void 0 : _g.path))
                endpoint['path'] = this.crudTable.server.path;
            if (!!((_h = this.crudTable.server) === null || _h === void 0 ? void 0 : _h.context))
                endpoint['context'] = this.crudTable.server.context;
            if (!!((_j = this.crudTable.server) === null || _j === void 0 ? void 0 : _j.endpoint))
                endpoint['endpoint'] = this.crudTable.server.endpoint;
            if (!!((_k = this.crudTable.server) === null || _k === void 0 ? void 0 : _k.headers))
                endpoint['headers'] = this.crudTable.server.headers;
            if (!!((_l = this.crudTable.server) === null || _l === void 0 ? void 0 : _l.params))
                endpoint['params'] = Object.assign(Object.assign({}, endpoint['params']), this.crudTable.server.params);
        }
        if (!!this.crudTable.path)
            endpoint['path'] = this.crudTable.path;
        if (!!this.crudTable.context)
            endpoint['context'] = this.crudTable.context;
        if (!!this.crudTable.endpoint)
            endpoint['endpoint'] = [this.crudTable.endpoint];
        if (!!this.crudTable.params)
            endpoint['params'] = Object.assign(Object.assign({}, endpoint['params']), this.crudTable.params);
        if (!endpoint.path && !endpoint.context && this.crudTable.selectServerData === 'request') {
            console.error('druc-data-table:', 'Nenhum endereço de busca foi informado a tabela');
        }
        endpoint['params'] = Object.assign(Object.assign(Object.assign(Object.assign({}, endpoint['params']), (!!this.crudTable.persistentParams ? this.crudTable.persistentParams : {})), this.crudTable.Pagination.getPagination()), this.crudTable.entityMap.configEntityTable.where);
        if (!!this.crudTable.service) {
            if (!!this.crudTable.service.endpoints.get('findAll')) {
                const findAllEndpoint = this.crudTable.service.endpoints.get('findAll');
                if (!!(findAllEndpoint === null || findAllEndpoint === void 0 ? void 0 : findAllEndpoint.params)) {
                    endpoint.params = Object.assign(Object.assign({}, findAllEndpoint.params), endpoint.params);
                }
            }
        }
        return endpoint;
    }
}

class CrudTablePaginationService {
    constructor(crudTable) {
        this.crudTable = crudTable;
    }
    initialize() {
        this._startSize();
        this._startSort();
    }
    getPagination() {
        const _a = this.crudTable.pagination, { sort, size, page } = _a, rest = __rest(_a, ["sort", "size", "page"]);
        return { sort, size, page };
    }
    setAttPagination(data) {
        var _a;
        if (!((_a = this.crudTable.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.pagination)) {
            this.crudTable.entityMap.configEntityTable['pagination'] = {};
        }
        if (data === null || data === void 0 ? void 0 : data.size) {
            this.crudTable.pagination.size = data.size;
            this.crudTable.entityMap.configEntityTable.pagination['size'] = data.size;
        }
        if (data === null || data === void 0 ? void 0 : data.sort) {
            this.crudTable.pagination.sort = data.sort;
            this.crudTable.entityMap.configEntityTable.pagination['sort'] = data.sort;
        }
        if (!!(data === null || data === void 0 ? void 0 : data.page) || (data === null || data === void 0 ? void 0 : data.page) == 0) {
            this.crudTable.pagination.page = data.page;
            this.crudTable.entityMap.configEntityTable.pagination['page'] = data.page;
        }
        if (data === null || data === void 0 ? void 0 : data.totalPages) {
            this.crudTable.pagination.totalPages = data.totalPages;
            this.crudTable.entityMap.configEntityTable.pagination['totalPages'] = data.totalPages;
        }
        if (data === null || data === void 0 ? void 0 : data.totalElements) {
            this.crudTable.pagination.totalElements = data.totalElements;
            this.crudTable.entityMap.configEntityTable.pagination['totalElements'] = data.totalElements;
        }
        //mesmo parecendo redundante, essa parte é importante para forçar a atualização
        //dos parametros nos demais componentes
        this.crudTable.entityMap.configEntityTable.pagination = Object.assign({}, this.crudTable.entityMap.configEntityTable.pagination);
    }
    resolve_params_pagination() {
        var _a, _b;
        let size = undefined;
        let sort = undefined;
        let pagination = {};
        if (!!((_b = (_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.configEntityTable) === null || _b === void 0 ? void 0 : _b.pagination)) {
            const _c = this.crudTable.entityMap.configEntityTable.pagination, { totalPages, totalElements } = _c, restPagination = __rest(_c, ["totalPages", "totalElements"]);
            pagination = restPagination;
        }
        if (this.crudTable.size !== null) {
            if (!!this.crudTable.size) {
                size = this.crudTable.size;
            }
            else if (!!(pagination === null || pagination === void 0 ? void 0 : pagination.size)) {
                size = pagination.size;
            }
            else if (this.crudTable.size === undefined) {
                size = '10';
            }
        }
        if (this.crudTable.sort === null) {
            if (!!this.crudTable.service) {
                this.crudTable.service.removeParams('findAll', ['sort']);
            }
            return Object.assign(Object.assign({}, pagination), { size });
        }
        if (!!this.crudTable.sort) {
            sort = this.crudTable.sort;
        }
        else if (!!(pagination === null || pagination === void 0 ? void 0 : pagination.sort)) {
            sort = pagination.sort;
        }
        else if (this.crudTable.sort === undefined) {
            sort = 'id,desc';
        }
        if (!!sort)
            this.crudTable._sort = sort;
        return Object.assign(Object.assign({}, pagination), { size });
    }
    changeSort(colum) {
        var _a, _b, _c, _d, _e, _f;
        if (!((_c = (_b = (_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.configEntityTable) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.sort)) {
            return;
        }
        const result = !!((_f = (_e = (_d = this.crudTable.entityMap) === null || _d === void 0 ? void 0 : _d.configEntityTable) === null || _e === void 0 ? void 0 : _e.pagination) === null || _f === void 0 ? void 0 : _f.sort)
            ? this.crudTable.entityMap.configEntityTable.pagination.sort.split(',') : [];
        if (colum == result[0]) {
            result[1] = result[1] == 'asc' ? 'desc' : 'asc';
        }
        else {
            result[0] = colum;
            result[1] = 'asc';
        }
        const sort = result.join(',');
        this.crudTable.entityMap.configEntityTable.pagination.sort = sort;
        this.crudTable.pagination['sort'] = sort;
        this.crudTable._pesquisar();
    }
    changePages(data) {
        this.setAttPagination({
            page: data.page,
            size: data.size
        });
        this.crudTable._pesquisar();
    }
    /**
     * Inicializa o size da tabela.
     * Metodo irá buscar as infoemações de size nessa ordem;
     * 1 - Input
     * 2 - size informado na entidade
     * 3 - se não houver nada, adiciona o valor 10
     * @private
     */
    _startSize() {
        var _a, _b;
        let pagination = {};
        if (!!((_b = (_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.configEntityTable) === null || _b === void 0 ? void 0 : _b.pagination)) {
            const _c = this.crudTable.entityMap.configEntityTable.pagination, { totalPages, totalElements } = _c, restPagination = __rest(_c, ["totalPages", "totalElements"]);
            pagination = restPagination;
        }
        if (this.crudTable.size !== null) {
            if (!!this.crudTable.size) {
                this.setAttPagination({ size: this.crudTable.size });
            }
            else if (!!(pagination === null || pagination === void 0 ? void 0 : pagination.size)) {
                this.setAttPagination({ size: pagination.size });
            }
            else if (this.crudTable.size === undefined) {
                this.setAttPagination({ size: 10 });
            }
        }
    }
    _startSort() {
        var _a, _b;
        let pagination = {};
        if (!!((_b = (_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.configEntityTable) === null || _b === void 0 ? void 0 : _b.pagination)) {
            const _c = this.crudTable.entityMap.configEntityTable.pagination, { totalPages, totalElements } = _c, restPagination = __rest(_c, ["totalPages", "totalElements"]);
            pagination = restPagination;
        }
        if (this.crudTable.sort === null) {
            if (!!this.crudTable.service) {
                this.crudTable.service.removeParams('findAll', ['sort']);
            }
        }
        if (!!this.crudTable.sort) {
            this.setAttPagination({ sort: this.crudTable.sort });
        }
        else if (!!(pagination === null || pagination === void 0 ? void 0 : pagination.sort)) {
            this.setAttPagination({ sort: pagination.sort });
        }
        else if (this.crudTable.sort === undefined) {
            this.setAttPagination({ sort: 'id,desc' });
        }
    }
}

function resolveEndpointUrl(endpoint) {
    const path = endpoint.path.endsWith('/') ? endpoint.path.substring(0, endpoint.path.length - 1) : endpoint.path;
    let context = endpoint.context.startsWith('/') ? endpoint.context.substring(1) : endpoint.context;
    context = context.endsWith('/') ? context.substring(0, context.length - 1) : context;
    let endpointContext = !!(endpoint === null || endpoint === void 0 ? void 0 : endpoint.endpoint) ? [...endpoint.endpoint] : [];
    let result = path + (!!context ? '/' + context : '');
    if (!!endpointContext) {
        if (Array.isArray(endpointContext)) {
            if (endpointContext.length > 0) {
                endpointContext = endpointContext.join('/');
            }
            else {
                return result;
            }
        }
        if (endpointContext.startsWith('/'))
            endpointContext = endpointContext.substring(1);
        if (endpointContext.endsWith('/'))
            endpointContext = endpointContext.substring(endpointContext.length - 1);
        return result + (!!endpointContext ? '/' + endpointContext : '');
    }
    return result;
}
function resolveParams(endpoint) {
    return {
        params: !!endpoint.params ? endpoint.params : {},
        headers: !!endpoint.headers ? endpoint.headers : {},
    };
}
function resolveEndpointParamCombine(endpoint1, endpoint2) {
    const result = Object.assign({}, endpoint1);
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.params)) {
        result.params = Object.assign(Object.assign({}, result.params), endpoint2.params);
    }
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.endpoint)) {
        result.endpoint = [
            ...(!!result.endpoint ? result.endpoint : []),
            ...(!!endpoint2.endpoint ? endpoint2.endpoint : [])
        ].filter(filter => !!filter);
    }
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.headers)) {
        result.headers = Object.assign(Object.assign({}, result.headers), endpoint2.headers);
    }
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.context)) {
        result.context = endpoint2.context;
    }
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.path)) {
        result.path = endpoint2.path;
    }
    if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.method)) {
        result.method = endpoint2.method;
    }
    return result;
}
function resolve_dictionary(data, dictionary) {
    return data.map((dat) => {
        if (typeof dictionary == 'object') {
            return _transpileDictionaryObject(dat, dictionary);
        }
        else if (typeof dictionary == 'function') {
            return dictionary(dat);
        }
    });
}
function _transpileDictionaryObject(data, dictionary) {
    Object.keys(dictionary).map((dictio) => {
        // @ts-ignore
        const field = dictionary[dictio];
        if (typeof field == 'string') {
            if (field in data) {
                // @ts-ignore
                data[dictio] = data[field];
                // @ts-ignore
                delete data[field];
            }
        }
        else if (Array.isArray(field)) {
            // @ts-ignore
            data[dictio] = data;
            field.map((nivelArray) => {
                // @ts-ignore
                if (!!data[dictio]) {
                    // @ts-ignore
                    if (nivelArray in data[dictio]) {
                        // @ts-ignore
                        data[dictio] = data[dictio][nivelArray];
                    }
                    else {
                        // @ts-ignore
                        data[dictio] = null;
                    }
                }
            });
        }
    });
    return data;
}
function saveOrUpdate(data, identificador) {
    if (typeof data == 'object') {
        if (identificador in data) {
            if (!!data[identificador]) {
                return 'update';
            }
        }
    }
    if (data instanceof FormData) {
        if (!!data.get(identificador)) {
            return 'update';
        }
    }
    return 'save';
}

class CrudTableActionsService {
    constructor(crudTable) {
        this.defaultActions = [
            { name: 'Editar', action: (row) => this.irParaEditar(row), permission: true },
            { name: 'Excluir', action: (row) => this.excluir(row.id), permission: true }
        ];
        this.crudTable = crudTable;
    }
    initialize() {
        var _a, _b;
        if (!!this.crudTable.customActions) {
            this.crudTable.tableAction = this._insert_actions(this.defaultActions, this.crudTable.customActions);
        }
        else if ((_a = this.crudTable.entityMap) === null || _a === void 0 ? void 0 : _a.serviceAction) {
            this._resolveByAbstractTableActions();
        }
        else if (Array.isArray((_b = this.crudTable.entityMap.configEntityTable) === null || _b === void 0 ? void 0 : _b.customActions)) {
            this._resolveByEntityArray();
        }
        // BUSCA POR DEFAULT ACTION
        else if (typeof this.crudTable.showDefaultAction === 'string') {
            if (this.crudTable.showDefaultAction === 'editar') {
                this.crudTable.tableAction = [this.defaultActions[0]];
            }
            else {
                this.crudTable.tableAction = [this.defaultActions[1]];
            }
        }
        // VERIFICA DEFAULT ACTIONS
        else if (this.crudTable.showDefaultAction) {
            this.crudTable.tableAction = this.defaultActions;
        }
    }
    actionDbClick(element) {
        if (this.crudTable.customDblclick) {
            this.crudTable.dblclick.emit(element);
        }
        else if (this.crudTable.dblclick === null) {
            return;
        }
        else {
            const index = this.defaultActions.findIndex(action => action.name.toUpperCase() == 'EDITAR');
            if (index != -1) {
                this.defaultActions[index].action(element);
            }
        }
    }
    _insert_actions(defaultActions, customActions) {
        const result = defaultActions;
        customActions.map((filter) => {
            const indexDefaultAction = defaultActions.findIndex((defAction) => defAction.name.toUpperCase() == filter.name.toUpperCase());
            if (indexDefaultAction != -1) {
                result.splice(indexDefaultAction, 1, filter);
            }
            else {
                result.push(filter);
            }
        });
        return result;
    }
    _resolveByAbstractTableActions() {
        var _a, _b;
        // instancia actionsService
        this.crudTable.ActionService = this.crudTable.injector.get(this.crudTable.entityMap.serviceAction);
        // verifica fixed service
        this.crudTable.fixedActionColum = this.crudTable.ActionService.fixedColumnActions;
        if (typeof this.crudTable.showDefaultAction === 'boolean' && this.crudTable.showDefaultAction) {
            this.crudTable.tableAction = this._insert_actions(this.defaultActions, this.crudTable.ActionService.list());
            if (Array.isArray((_a = this.crudTable.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.customActions)) {
                this.crudTable.tableAction = this._insert_actions(this.crudTable.tableAction, (_b = this.crudTable.entityMap.configEntityTable) === null || _b === void 0 ? void 0 : _b.customActions);
            }
        }
        else if (typeof this.crudTable.showDefaultAction === 'string') {
            if (this.crudTable.showDefaultAction === 'editar') {
                this.crudTable.tableAction = [
                    this.defaultActions[0],
                    ...this.crudTable.ActionService.list()
                ];
            }
            else {
                this.crudTable.tableAction = [
                    this.defaultActions[1],
                    ...this.crudTable.ActionService.list()
                ];
            }
        }
        else {
            this.crudTable.tableAction = this.crudTable.ActionService.list();
        }
    }
    _resolveByEntityArray() {
        if (!Array.isArray(this.crudTable.entityMap.configEntityTable.customActions))
            return;
        this.crudTable.tableAction = this._insert_actions(this.defaultActions, this.crudTable.entityMap.configEntityTable.customActions);
    }
    /**
     * METODOS DE AÇÃO DA TABELA
     */
    irParaEditar(element) {
        this.crudTable.router.navigate([`${window.location.pathname}/${element.id}`]).then();
    }
    excluir(id) {
        Swal.fire({
            title: 'Excluir registro',
            text: "Deseja excluir este registro? Esta ação é permanente.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Deletar'
        }).then((result) => {
            if (result.isConfirmed) {
                const endpoint = this.crudTable.Initialize.resolveServiceParams();
                if (!!this.crudTable.contextDelete) {
                    endpoint['context'] = this.crudTable.contextDelete;
                }
                endpoint['endpoint'] = [id];
                // this.service.deleteOne(id)
                this.crudTable.http.delete(resolveEndpointUrl(endpoint))
                    .subscribe(() => {
                    this.crudTable._pesquisar();
                    if (this.crudTable.callbackEdit) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Deletado com sucesso!',
                            text: 'Este registro foi deletado.',
                            showConfirmButton: false,
                            timer: 1500
                        }).then();
                    }
                    this.crudTable.callbackMessageEdit.emit({ status: 'success' });
                }, (error) => {
                    if (this.crudTable.callbackEdit) {
                        Swal.fire('Erro', 'Não foi possível remover esse registro.', 'error').then();
                    }
                    this.crudTable.callbackMessageEdit.emit({ status: 'error', data: error });
                });
            }
        });
    }
}

class CrudTableFindService {
    constructor(crudTable) {
        this.crudTable = crudTable;
    }
    pesquisar(init = false) {
        var _a, _b, _c, _d;
        this.crudTable.loading = true;
        if (!!this.crudTable.data || this.crudTable.selectServerData === 'array') {
            this._findByArray(this.crudTable.Initialize.resolveServiceParams());
        }
        else {
            if (init && ((_a = this.crudTable) === null || _a === void 0 ? void 0 : _a.register) && ((_b = this.crudTable) === null || _b === void 0 ? void 0 : _b.tableEventId)) {
                if (this.crudTable.onRegister.verifyTableExist((_c = this.crudTable) === null || _c === void 0 ? void 0 : _c.tableEventId)) {
                    this._findByRequest(Object.assign(Object.assign({}, this.crudTable.Initialize.resolveServiceParams()), { params: Object.assign(Object.assign({}, this.crudTable.Initialize.resolveServiceParams().params), this.crudTable.onRegister.getTable((_d = this.crudTable) === null || _d === void 0 ? void 0 : _d.tableEventId)) }));
                    return;
                }
            }
            this._findByRequest(this.crudTable.Initialize.resolveServiceParams());
        }
    }
    findByFilters() {
        this.crudTable.loading = true;
        const endpoint = this.crudTable.Initialize.resolveServiceParams();
        if (!!endpoint.params) {
            endpoint.params = Object.assign(Object.assign({}, endpoint.params), { page: 0 });
        }
        if (!!this.crudTable.data || this.crudTable.selectServerData === 'array') {
            this._findByArray(endpoint);
        }
        else {
            this._findByRequest(endpoint);
        }
    }
    _findByArray(endpoint) {
        if (!this.crudTable.data)
            return;
        this.crudTable.Pagination.setAttPagination({ totalElements: this.crudTable.data.length });
        if (this.crudTable.pagination.size) {
            this.crudTable.Pagination.setAttPagination({
                totalPages: Math.ceil(this.crudTable.data.length / Number(this.crudTable.pagination.size))
            });
        }
        this.crudTable.dataSource = [];
        if (this.crudTable.pagination.size) {
            setTimeout(() => {
                if (!this.crudTable.data)
                    return;
                this.crudTable.dataSource = this._findFilterByArray(endpoint).slice(Number(this.crudTable.pagination.page) * Number(this.crudTable.pagination.size), (Number(this.crudTable.pagination.page) + 1) * Number(this.crudTable.pagination.size));
            }, 10);
        }
        else {
            this.crudTable.dataSource = this.crudTable.data;
        }
        this.crudTable.loading = false;
    }
    _findByRequest(endpoint) {
        let request = this.crudTable.http.get(resolveEndpointUrl(endpoint), Object.assign({}, resolveParams(endpoint)));
        let registerData = endpoint.params;
        if (!!this.crudTable.service) {
            request = this.crudTable.service.get('', endpoint);
            registerData = Object.assign({}, resolveParams(endpoint)).params;
        }
        request.subscribe((resp) => {
            var _a;
            if (!!this.crudTable.resourceDictionary) {
                if (!!this.crudTable.dictionary) {
                    this.crudTable.dataSource = resolve_dictionary(this.crudTable.resourceDictionary(resp.data || resp), this.crudTable.dictionary);
                }
                else if (!!this.crudTable.service) {
                    this.crudTable.dataSource = this.crudTable.service.dictionaryFindAll(this.crudTable.resourceDictionary(resp.data || resp));
                }
                else {
                    this.crudTable.dataSource = this.crudTable.resourceDictionary(resp.data || resp);
                }
            }
            else {
                if (!!this.crudTable.dictionary) {
                    this.crudTable.dataSource = resolve_dictionary(resp.data, this.crudTable.dictionary);
                }
                else if (!!this.crudTable.service) {
                    this.crudTable.dataSource = this.crudTable.service.dictionaryFindAll(resp.data);
                }
                else {
                    this.crudTable.dataSource = resp.data;
                }
            }
            this.crudTable.loading = false;
            if (((_a = this.crudTable.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.pagination) && resp.page) {
                this.crudTable.entityMap.configEntityTable.pagination = Object.assign(Object.assign({}, this.crudTable.entityMap.configEntityTable.pagination), { totalElements: Number(!!resp.page.totalElements ? resp.page.totalElements : 0), totalPages: Number(!!resp.page.totalPages ? resp.page.totalPages : 0), page: Number(!!resp.page.number ? resp.page.number : 0), size: Number(!!resp.page.size ? resp.page.size : 0) });
                this.register(registerData);
            }
        });
    }
    _findFilterByArray(endpoint) {
        if ((this.crudTable.data || []).length <= 0)
            return this.crudTable.data || [];
        const params = endpoint.params || {};
        if ('sort' in params)
            delete params['sort'];
        if ('size' in params)
            delete params['size'];
        if ('page' in params)
            delete params['page'];
        const arrayParams = Object.keys(params);
        if (arrayParams.length > 0) {
            let resultData = this.crudTable.data || [];
            arrayParams.map(param => {
                if (!params[param])
                    return;
                resultData = resultData.filter((e) => {
                    if (!(param in e))
                        return false;
                    if (!e[param])
                        return false;
                    return this._clearString(String(e[param]))
                        .toLowerCase().indexOf(this._clearString(String(params[param])).toLowerCase()) != -1;
                });
            });
            return resultData;
        }
        return this.crudTable.data || [];
    }
    _clearString(str) {
        if (typeof str !== "string") {
            return 'error';
        }
        str = str.replace(/a|A|á|Á|â|Â|à|À|ä|Ä|ã|Ã/g, 'a');
        str = str.replace(/e|E|é|É|ê|Ê|è|È|ë|Ë/g, 'e');
        str = str.replace(/i|I|í|Í|î|Î|ì|Ì|ï|Ï/g, 'i');
        str = str.replace(/u|U|ú|Ú|û|Û|ù|Ù|ü|Ü/g, 'u');
        str = str.replace(/o|O|ó|Ó|ô|Ô|ò|Ò|ö|Ö|õ|Õ/g, 'o');
        str = str.replace(/c|C|ç|Ç/g, 'ç');
        return str.toUpperCase();
    }
    register(data) {
        var _a, _b;
        if (((_a = this.crudTable) === null || _a === void 0 ? void 0 : _a.register) && ((_b = this.crudTable) === null || _b === void 0 ? void 0 : _b.tableEventId)) {
            this.crudTable.onRegister.setTable(this.crudTable.tableEventId, data);
        }
    }
    register2() {
        var _a, _b;
        if (((_a = this.crudTable) === null || _a === void 0 ? void 0 : _a.register) && ((_b = this.crudTable) === null || _b === void 0 ? void 0 : _b.tableEventId)) {
            this.crudTable.onRegister.setTable(this.crudTable.tableEventId, Object.assign({}, this.crudTable.entityMap.configEntityTable.pagination));
        }
    }
}

// import  * as Crypto from 'crypto';
class RegisterCrudTableService {
    constructor(route, router) {
        this.route = route;
        this.router = router;
    }
    setTable(eventKey, tableValues) {
        let paginations = {};
        if (this.route.snapshot.queryParams['paginations']) {
            paginations = JSON.parse(this.route.snapshot.queryParams['paginations']);
        }
        paginations[eventKey] = tableValues;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                paginations: (Object.keys(paginations).length > 0 ? JSON.stringify(paginations) : null)
            },
            queryParamsHandling: 'merge'
        }).then();
    }
    verifyTableExist(eventKey) {
        if (this.route.snapshot.queryParams['paginations']) {
            const paginations = JSON.parse(this.route.snapshot.queryParams['paginations']);
            if (eventKey in paginations) {
                return true;
            }
        }
        return false;
    }
    getTable(eventKey) {
        if (this.verifyTableExist(eventKey)) {
            const paginations = JSON.parse(this.route.snapshot.queryParams['paginations']);
            return paginations[eventKey];
        }
        return {};
    }
    //######################################################################
    setFilter(eventKey, value) {
        let filters = {};
        if (this.route.snapshot.queryParams['filters']) {
            filters = JSON.parse(this.route.snapshot.queryParams['filters']);
        }
        filters[eventKey] = value;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                filters: (Object.keys(filters).length > 0 ? JSON.stringify(filters) : null)
            },
            queryParamsHandling: 'merge'
        }).then();
    }
    getFilters(eventKey, key) {
        if (this.verifyFilterExist(eventKey, key)) {
            const paginations = JSON.parse(this.route.snapshot.queryParams['filters']);
            if (!!key) {
                return paginations[eventKey][key];
            }
            return paginations[eventKey];
        }
        return {};
    }
    verifyFilterExist(eventKey, key) {
        if (!eventKey)
            return false;
        if (this.route.snapshot.queryParams['filters']) {
            const filters = JSON.parse(this.route.snapshot.queryParams['filters']);
            if (eventKey in filters) {
                if (!!key) {
                    return key in filters[eventKey];
                }
                return true;
            }
        }
        return false;
    }
    clearFilter(eventKey) {
        let filters = {};
        if (this.route.snapshot.queryParams['filters']) {
            filters = JSON.parse(this.route.snapshot.queryParams['filters']);
        }
        filters[eventKey] = null;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                filters: (Object.values(filters).filter(item => !!item).length > 0 ? JSON.stringify(filters) : null)
            },
            queryParamsHandling: 'merge'
        }).then();
    }
}
RegisterCrudTableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RegisterCrudTableService, deps: [{ token: i1$1.ActivatedRoute }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
RegisterCrudTableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RegisterCrudTableService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: RegisterCrudTableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ActivatedRoute }, { type: i1$1.Router }]; } });

class LoadingTableComponent {
    constructor() {
        this.colorLoad = '#69aff5';
        this.colorLoadText = 'black';
    }
    ngOnInit() {
    }
}
LoadingTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoadingTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoadingTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: LoadingTableComponent, selector: "loading-table", inputs: { colorLoad: "colorLoad", colorLoadText: "colorLoadText" }, ngImport: i0, template: "<div\r\n  class=\"loading-container\"\r\n  [style.--colorLoad]=\"colorLoad\"\r\n  [style.--colorLoadText]=\"colorLoadText\"\r\n>\r\n  <div class=\"loading\"></div>\r\n  <div id=\"loading-text\">Carregando</div>\r\n</div>\r\n", styles: ["#link:hover{color:var(--colorLoad)}#link,#link:hover{transition:color .5s ease-out}body{background:#333333}@keyframes rotate-loading{0%{transform:rotate(0);-ms-transform:rotate(0deg);-webkit-transform:rotate(0deg);-o-transform:rotate(0deg);-moz-transform:rotate(0deg)}to{transform:rotate(360deg);-ms-transform:rotate(360deg);-webkit-transform:rotate(360deg);-o-transform:rotate(360deg);-moz-transform:rotate(360deg)}}@keyframes loading-text-opacity{0%{opacity:0}20%{opacity:0}50%{opacity:1}to{opacity:0}}.loading-container,.loading{height:100px;position:relative;width:100px;border-radius:100%}.loading-container{margin:40px auto}.loading{border:2px solid transparent;border-color:transparent var(--colorLoad) transparent var(--colorLoad);-moz-animation:rotate-loading 1.5s linear 0s infinite normal;-moz-transform-origin:50% 50%;-o-animation:rotate-loading 1.5s linear 0s infinite normal;-o-transform-origin:50% 50%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;-webkit-transform-origin:50% 50%;animation:rotate-loading 1.5s linear 0s infinite normal;transform-origin:50% 50%}.loading-container:hover .loading,.loading-container .loading{transition:all .5s ease-in-out}#loading-text{animation:loading-text-opacity 2s linear 0s infinite normal;color:var(--colorLoadText)!important;font-family:\"Helvetica Neue\",\"Helvetica\",\"arial\";font-size:10px;font-weight:bold;margin-top:45px;opacity:0;position:absolute;text-align:center;text-transform:uppercase;top:0;width:100px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: LoadingTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'loading-table',
                    templateUrl: './loading-table.component.html',
                    styleUrls: ['./loading-table.component.css']
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { colorLoad: [{
                type: Input,
                args: ['colorLoad']
            }], colorLoadText: [{
                type: Input,
                args: ['colorLoadText']
            }] } });

class DgDataTableComponent {
    constructor(route, sanitized) {
        this.route = route;
        this.sanitized = sanitized;
        // CRIANDO COLUNAS
        this.displayedColumns = [];
        this.colorLoad = '#69aff5';
        this.colorLoadText = 'black';
        this.customIconActions = 'more_vert';
        // verifica se deve apresentar o loading enquanto espera os dados
        this.loading = true;
        // mensagem em caso de
        this.message = 'Nenhum registro encontrado';
        // DATA DA TABELA
        this.dataSource = [];
        // VERIFICA SE DESEJA APRESENTAR O PAGINADOR
        this.showPagination = true;
        // RECEBE O CONJUNTO DE DADOS DE APRESENTAÇÃO (columns, actions...)
        this.columns = [];
        // RECEBE O CONJUNTO DE PERMISSÕES ADICIONAL PARA SER IMPLEMENTADO AS ACTIONS
        this.permissions = {
            adicionar: true,
            editar: true,
            deletar: true
        };
        // VERIFICA SE DESEJA APRESENTAR AS ACTIONS
        this.showActions = true;
        // RECEBE BOOLEANO QUE CONTROLA FIXED DE COLUNA ACTIONS
        this.fixedActionColum = false;
        // EMITE EVENTO DE DUPLO CLICK
        this.customDbClick = new EventEmitter();
        // EMITE EVENTO DE MUDANÇAS NO SORT
        this.sortChange = new EventEmitter();
    }
    ngOnInit() {
        if (this.showPagination) {
            this.setPagintation();
        }
        const newColuns = this.columns.map(column => column.varName);
        this.displayedColumns = newColuns;
        if (this.showActions && !!this.actions) {
            newColuns.push('actions');
        }
    }
    /**
     * mascaras já criapas para comodidade.
     * recebe ainda ‘string’ caso uma nova mascara seja requerida
     * @param mask
     */
    defauldMask(mask) {
        if (typeof mask != 'string')
            return '--';
        switch (mask) {
            case 'cpf':
                return '000.000.000-00';
            case 'cnpj':
                return '00.000.000/0000-00';
            case 'cep':
                return '00000-000';
            case 'telefone':
                return '(00) 0000-0000';
            case 'celular':
                return '(00) 0 0000-0000';
            case 'rg':
                return '00.000.000-0';
            case 'conta':
                return '00.000-0';
            case 'egencia':
                return '0000-0';
            case 'cnh':
                return '000000000-00';
            default:
                return mask;
        }
    }
    /**
     * Mascaras de data
     * @param value
     */
    maskDate(value) {
        if (!value)
            return '--';
        return new Date(value).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }
    maskDateTime(value) {
        if (!value)
            return '--';
        const date = new Date(value).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        const time = new Date(value).toLocaleTimeString('pt-BR', { timeZone: 'UTC' });
        return date + ' - ' + time;
    }
    /**
     * seta os dados de paginação
     */
    setPagintation() {
        var _a, _b, _c, _d;
        this.paginator._intl.itemsPerPageLabel = "Itens por página: ";
        this.paginator._intl.nextPageLabel = "Próxima página";
        this.paginator._intl.previousPageLabel = "Página Anterior";
        this.paginator._intl.lastPageLabel = "Ultima página";
        this.paginator._intl.firstPageLabel = "Primeira página";
        this.paginator._intl.firstPageLabel = "Primeira página";
        this.paginator._intl.firstPageLabel = "Primeira página";
        this.paginator.pageSize = Number((_b = (_a = this.entityMapping.configEntityTable) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.size);
        this.paginator.length = Number((_d = (_c = this.entityMapping.configEntityTable) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.totalElements);
    }
    /**
     * emite evento de DbClick custumizado
     * @param row
     */
    emitirDbClick(row) {
        this.customDbClick.emit(row);
    }
    /**
     * Verificando tipo do recurso utilizado
     * @param resource
     * @param celula
     * @param row
     * @param resourceMethod
     */
    resourceCel(resource, celula, row, resourceMethod) {
        const resoucArrayOrObj = () => {
            if (!!celula) {
                if (resource[celula]) {
                    return this.includeResourceCel(resource[celula]);
                }
                else {
                    console.warn('valor ' + celula + ' : nao encontrado em ' + JSON.stringify(Object.keys(resource)));
                    return '';
                }
            }
            else {
                return '';
            }
        };
        if (!!resourceMethod) {
            if (typeof resource === 'function') {
                return this.includeResourceCel(resource(celula, row));
            }
            if (resourceMethod === 'array' || resourceMethod === 'obj') {
                return resoucArrayOrObj();
            }
        }
        // quando um número é informa
        if (typeof resource === 'function') {
            return this.includeResourceCel(resource(celula, row));
            // retorna resource
        }
        if (Array.isArray(resource) && typeof celula === "number") {
            return resoucArrayOrObj();
        }
        if (typeof resource === 'object' && !Array.isArray(resource)) {
            return resoucArrayOrObj();
            // tratamento por função
        }
        if (!Array.isArray(resource) && typeof celula === "number") {
            return this.includeResourceCel(resource);
            // tratamento em array
        }
        if (typeof resource === 'boolean' || typeof resource === 'string') {
            return resource;
        }
        if (!!celula) {
            return celula;
        }
        return '--';
    }
    /**
     * incluindo html na celula
     * @param html
     */
    includeResourceCel(html) {
        return this.sanitized.bypassSecurityTrustHtml(html);
    }
    /**
     * emite evento informando que a ordem de paginação foi alterada
     * @param col
     */
    changeSort(col) {
        this.sortChange.emit(col);
    }
    /**
     * verifica as permissões para esconder ou mostrar o botão quando necessário
     * @param value
     * @param data
     */
    //TODO Mudar metodo para dentro de getActionsButtons() uma ves que a chamada de dados passou a ser desse metodo
    disabledCustomButton(value, data) {
        if (value === undefined) {
            return false;
        }
        if (typeof value === 'boolean') {
            return !value;
        }
        if (typeof value === 'string') {
            if (typeof this.permissions[`${value}`] === "boolean") {
                return !this.permissions[`${value}`];
            }
            else if (typeof this.permissions[`${value}`] === "function") {
                return !this.permissions[`${value}`](data);
            }
        }
        if (typeof value === 'function') {
            return !value(data);
        }
        return false;
    }
    /**
     * retorna icone correto a paginação
     */
    sortIcon(colum) {
        var _a;
        if ((_a = this.entityMapping.configEntityTable.pagination) === null || _a === void 0 ? void 0 : _a.sort) {
            const sort = this.entityMapping.configEntityTable.pagination.sort.split(',');
            if (colum == sort[0]) {
                if (sort[1] == 'asc') {
                    return 'expand_more';
                }
                else {
                    return 'expand_less';
                }
            }
        }
        return 'unfold_more';
    }
    htmlTypeOf(val) {
        return typeof val;
    }
    getActionsButtons(element) {
        if (!this.actions)
            return [];
        const list = this.actions.filter(action => !this.disabledCustomButton(action.permission, element));
        return list;
    }
}
DgDataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgDataTableComponent, deps: [{ token: i1$1.Router }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
DgDataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: DgDataTableComponent, selector: "dg-data-table", inputs: { colorLoad: "colorLoad", colorLoadText: "colorLoadText", customIconActions: "customIconActions", loading: "loading", message: "message", dataSource: "dataSource", showPagination: "showPagination", columns: "columns", permissions: "permissions", entityMapping: "entityMapping", showActions: "showActions", actions: "actions", fixedActionColum: "fixedActionColum", singleAction: "singleAction", propsActionButton: "propsActionButton" }, outputs: { customDbClick: "customDbClick", sortChange: "sortChange" }, viewQueries: [{ propertyName: "paginator", first: true, predicate: ["paginator"], descendants: true, static: true }], ngImport: i0, template: "<!--\r\n   TABELA PRINCIPAL. APRESENTANDO DADOS\r\n-->\r\n<table\r\n  *ngIf=\"dataSource.length > 0 && !loading\"\r\n  mat-table\r\n  [dataSource]=\"dataSource\"\r\n  class=\"mt-3 crud-table\"\r\n>\r\n\r\n  <!--- Note that these columns can be defined in any order.\r\n        The actual rendered columns are set as a property on the row definition\" -->\r\n\r\n  <!-- Position Column -->\r\n  <ng-container\r\n    *ngFor=\"let col of columns\"\r\n    matColumnDef=\"{{col.varName}}\"\r\n    [sticky]=\"col.fixedColumnStart\"\r\n    [stickyEnd]=\"col.fixedColumnEnd\"\r\n  >\r\n    <th\r\n      style=\"{{'width:'+ (col.width ? col.width : 'auto')}}\"\r\n      mat-header-cell\r\n      *matHeaderCellDef\r\n      [class.table-colum-fixed-end]=\"col.fixedColumnEnd\"\r\n      [class.table-colum-fixed-start]=\"col.fixedColumnStart\"\r\n    >\r\n      <span [class.sort-header]=\"col.sort\" (click)=\"(!!col.sort ? changeSort(col.varName) : null)\" style=\"display: inline-flex; align-items: center\">\r\n        {{col.header}}\r\n        <mat-icon *ngIf=\"col.sort\" style=\"display: inline-flex; align-items: center; padding: 0; font-size: 14pt\">\r\n          {{sortIcon(col.varName)}}\r\n        </mat-icon>\r\n      </span>\r\n    </th>\r\n    <td\r\n      mat-cell\r\n      class=\"{{col.columnClassName}}\"\r\n      *matCellDef=\"let element\"\r\n      [class.table-colum-fixed-end]=\"col.fixedColumnEnd\"\r\n      [class.table-colum-fixed-start]=\"col.fixedColumnStart\"\r\n      [innerHTML]=\"col.resource\r\n        ? resourceCel(col.resource, element[col.varName], element, col.declaratResourceMethod)\r\n        : col.mask\r\n\r\n          ? htmlTypeOf(col.mask) == 'string'\r\n            ? (\r\n                col.mask == 'date'\r\n                  ? maskDate(element[col.varName])\r\n                    : col.mask == 'date-time'\r\n                  ? maskDateTime(element[col.varName])\r\n                    : element[col.varName] | mask: defauldMask(col.mask)\r\n              )\r\n            : col.mask?.mask == 'decimal'\r\n              ? (element[col.varName] | number: col.mask?.decimalNumbers || '')\r\n              : (element[col.varName] | mask: 'separator.1':'.')\r\n\r\n          : element[col.varName]\"\r\n    >\r\n    </td>\r\n  </ng-container>\r\n\r\n  <ng-container\r\n    *ngIf=\"showActions === true\"\r\n    matColumnDef=\"actions\"\r\n    [stickyEnd]=\"fixedActionColum\"\r\n  >\r\n    <th [class.table-colum-fixed-end]=\"fixedActionColum\" mat-header-cell *matHeaderCellDef> A\u00E7\u00F5es </th>\r\n    <td\r\n      [class.table-colum-fixed-end]=\"fixedActionColum\"\r\n      mat-cell\r\n      *matCellDef=\"let element\"\r\n    >\r\n      <!--  BTN PADR\u00C3O  -->\r\n      <button\r\n        *ngIf=\"singleAction\"\r\n        class=\"button-menu {{singleAction?.classes}}\"\r\n        (click)=\"singleAction.action(element)\"\r\n      >\r\n        {{ singleAction?.name }}\r\n        <mat-icon *ngIf=\"singleAction?.action\">{{singleAction?.icon}}</mat-icon>\r\n      </button>\r\n\r\n      <button\r\n        *ngIf=\"!singleAction\"\r\n        class=\"button-menu {{ !!propsActionButton ? !!propsActionButton.classes ? propsActionButton.classes : '' : '' }}\"\r\n        [matMenuTriggerFor]=\"beforeMenu\"\r\n        [disabled]=\"getActionsButtons(element).length == 0\"\r\n      >\r\n        <mat-icon>{{customIconActions}}</mat-icon>\r\n      </button>\r\n\r\n      <mat-menu #beforeMenu=\"matMenu\" xPosition=\"before\">\r\n\r\n        <a\r\n          mat-menu-item\r\n          *ngFor=\"let customButton of getActionsButtons(element)\"\r\n          (click)=\"customButton.action(element)\"\r\n          [class.d-none]=\"disabledCustomButton(customButton.permission, element)\"\r\n        >\r\n          {{customButton.name}}\r\n        </a>\r\n      </mat-menu>\r\n    </td>\r\n  </ng-container>\r\n\r\n  <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n  <tr (dblclick)=\"customDbClick.observers.length > 0 ? emitirDbClick(row) : null\" mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n</table>\r\n\r\n\r\n<!--\r\n  TABELA DE APOIO. USADA PARA APRESENTA\u00C7\u00C3O DE LOADER E MENSAGEM DE NENHUM DADO ENCONTRADO\r\n-->\r\n<table\r\n  *ngIf=\"dataSource.length <= 0 || loading\"\r\n  class=\"mt-3 crud-table\"\r\n>\r\n  <thead>\r\n    <tr>\r\n      <th *ngFor=\"let col of columns\">{{ col.header }}</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n  <tr *ngIf=\"!loading\">\r\n    <td [colSpan]=\"columns.length\">\r\n      <p style=\"text-align: center; margin-top: 1.5rem\">{{message}}</p>\r\n    </td>\r\n  </tr>\r\n  <tr *ngIf=\"loading\">\r\n    <td [colSpan]=\"columns.length\">\r\n      <loading-table [colorLoad]=\"colorLoad\" [colorLoadText]=\"colorLoadText\"></loading-table>\r\n    </td>\r\n  </tr>\r\n  </tbody>\r\n</table>\r\n", styles: ["::ng-deep .crud-table{position:relative;width:auto}.crud-table .sort-header{cursor:pointer}.d-none{display:none}::ng-deep .mat-paginator-range-actions svg{fill:gray!important}::ng-deep .mat-tooltip{color:#fff!important;background-color:#0009}::ng-deep .mat-button-disabled svg{opacity:60%}\n"], components: [{ type: i3.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i5.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { type: i5.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { type: i3.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i3.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { type: LoadingTableComponent, selector: "loading-table", inputs: ["colorLoad", "colorLoadText"] }], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i3.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i3.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i3.MatCellDef, selector: "[matCellDef]" }, { type: i3.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { type: i3.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i3.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }], pipes: { "mask": i5$1.MaskPipe, "number": i1.DecimalPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgDataTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dg-data-table',
                    templateUrl: './dg-data-table.component.html',
                    styleUrls: ['./dg-data-table.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: i2.DomSanitizer }]; }, propDecorators: { colorLoad: [{
                type: Input,
                args: ['colorLoad']
            }], colorLoadText: [{
                type: Input,
                args: ['colorLoadText']
            }], customIconActions: [{
                type: Input,
                args: ['customIconActions']
            }], loading: [{
                type: Input,
                args: ['loading']
            }], message: [{
                type: Input,
                args: ['message']
            }], dataSource: [{
                type: Input
            }], paginator: [{
                type: ViewChild,
                args: ['paginator', { static: true }]
            }], showPagination: [{
                type: Input,
                args: ['showPagination']
            }], columns: [{
                type: Input
            }], permissions: [{
                type: Input
            }], entityMapping: [{
                type: Input
            }], showActions: [{
                type: Input
            }], actions: [{
                type: Input
            }], fixedActionColum: [{
                type: Input
            }], singleAction: [{
                type: Input
            }], customDbClick: [{
                type: Output
            }], sortChange: [{
                type: Output
            }], propsActionButton: [{
                type: Input
            }] } });

class CrudDataTableComponent {
    constructor(injector, router, http, onRegister) {
        this.injector = injector;
        this.router = router;
        this.http = http;
        this.onRegister = onRegister;
        this.Initialize = new CrudTableInitializeService(this);
        this.Pagination = new CrudTablePaginationService(this);
        this.Actions = new CrudTableActionsService(this);
        this.Find = new CrudTableFindService(this);
        // lista de registros apresentados na tabela
        this.dataSource = [];
        // Seleciona manualmente a forma de busca e da tabela
        // Util em casos de conflito, onde a própria crud-data-table não consiga
        // definir com perfeição o metodo requerido
        this.selectServerData = 'request';
        /*************************************************************************
         * INPUTS referentes a PAGINAÇÃO
         */
        this.size = undefined;
        this.sort = 'id,asc';
        this._sort = '';
        this.pagination = {
            size: 10,
            sort: 'id,asc',
            page: 0,
            totalPages: 0,
            totalElements: 0
        };
        /**
         * @deprecated
         */
        this.showPagination = false;
        this.customDblclick = false;
        this.callbackEdit = true;
        this.customIconActions = 'more_vert';
        this.showDefaultAction = true;
        this.path = '';
        this.context = '';
        this.contextDelete = undefined;
        this.fetchStart = true;
        this.register = false;
        /*************************************************************************
         * LOADERS
         */
        this.colorLoad = '#69aff5';
        this.colorLoadText = 'black';
        this.loading = true;
        /*************************************************************************
         * UI
         */
        // fixar coluna de ações
        this.fixedActionColum = false;
        /*************************************************************************
         * OUTPUTS
         */
        this.callbackMessageEdit = new EventEmitter();
        this.dblclick = new EventEmitter();
        // @Input() columns: InterfaceColumns[] | undefined;
        this.tableColumns = [];
        this._pesquisar = () => this.Find.pesquisar();
        this.changePages = (data) => this.Pagination.changePages(data);
    }
    ngOnInit() {
        this.Initialize.initialize();
        this.Pagination.initialize();
        this.Actions.initialize();
        // this.Actions._verify_actions();
        if (!this.tableEventId) {
            this.tableEventId = this.entityMap.constructor.name;
        }
        if (this.fetchStart) {
            this.Find.pesquisar(true);
        }
    }
    // BUSCAR DADOS
    pesquisar(data) {
        var _a;
        const tableEventId = tableEventKey(String(this.tableEventId), data);
        if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
            return;
        }
        if (!!this.service) {
            this.service.removeParams('findAll', ['page']);
        }
        if ((_a = this.entityMap.configEntityTable.pagination) === null || _a === void 0 ? void 0 : _a.page) {
            this.entityMap.configEntityTable.pagination.page = 0;
        }
        this.Find.pesquisar();
    }
    findByFilters(data) {
        var _a;
        const tableEventId = tableEventKey(String(this.tableEventId), data);
        if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
            return;
        }
        if (!!this.service) {
            this.service.removeParams('findAll', ['page']);
        }
        if ((_a = this.entityMap.configEntityTable.pagination) === null || _a === void 0 ? void 0 : _a.page) {
            this.entityMap.configEntityTable.pagination.page = 0;
        }
        this.Find.findByFilters();
    }
    // LIMPAR FILTROS DE PAGINAÇÃO
    clear(data) {
        var _a, _b, _c, _d, _e;
        if (!((_c = (_b = (_a = this.entityMap) === null || _a === void 0 ? void 0 : _a.configEntityTable) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.sort)) {
            return;
        }
        const tableEventId = tableEventKey(String(this.tableEventId), data);
        if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
            return;
        }
        if (!!this.service) {
            const findAll = this.service.endpoints.get('findAll');
            if (!!findAll) {
                findAll['params'] = {};
            }
            this.service.endpoints.set('findAll', findAll);
        }
        if ((_e = (_d = this.entityMap.configEntityTable) === null || _d === void 0 ? void 0 : _d.pagination) === null || _e === void 0 ? void 0 : _e.page) {
            this.entityMap.configEntityTable.pagination.page = 0;
        }
        if (this.sort !== null) {
            this.entityMap.configEntityTable.pagination.sort = this.sort;
        }
        else {
            if (!!this.service) {
                this.service.removeParams('findAll', ['sort']);
            }
        }
        this.Find.findByFilters();
    }
}
CrudDataTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudDataTableComponent, deps: [{ token: i0.Injector }, { token: i1$1.Router }, { token: i1$2.HttpClient }, { token: RegisterCrudTableService }], target: i0.ɵɵFactoryTarget.Component });
CrudDataTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CrudDataTableComponent, selector: "crud-data-table", inputs: { entityMap: "entityMap", service: "service", tableEventId: "tableEventId", data: "data", selectServerData: ["select-server-data", "selectServerData"], size: "size", sort: "sort", showPagination: "showPagination", customActions: "customActions", singleAction: "singleAction", customDblclick: "customDblclick", callbackEdit: "callbackEdit", propsActionButton: "propsActionButton", customIconActions: "customIconActions", showDefaultAction: "showDefaultAction", params: "params", persistentParams: "persistentParams", endpoint: "endpoint", path: "path", context: "context", contextDelete: "contextDelete", server: "server", fetchStart: "fetchStart", register: "register", dictionary: "dictionary", resourceDictionary: "resourceDictionary", colorLoad: "colorLoad", colorLoadText: "colorLoadText", loading: "loading" }, outputs: { callbackMessageEdit: "callbackMessageEdit", dblclick: "dblclick" }, host: { listeners: { "window:dg-table-atualizar-event": "pesquisar($event)", "window:dg-table-atualizar-event-filter": "findByFilters($event)", "window:dg-table-clear-event": "clear($event)" } }, ngImport: i0, template: "<dg-data-table\r\n  class=\"generic-crudTable-key\"\r\n  [columns]=\"tableColumns\"\r\n  [actions]=\"tableAction\"\r\n  [entityMapping]=\"entityMap\"\r\n  [dataSource]=\"dataSource\"\r\n  [showPagination]=\"(showPagination && !!entityMap?.configEntityTable?.pagination)\"\r\n  [loading]=\"loading\"\r\n  [customIconActions]=\"customIconActions\"\r\n  [fixedActionColum]=\"fixedActionColum\"\r\n  [propsActionButton]=\"propsActionButton\"\r\n  [singleAction]=\"singleAction\"\r\n  (sortChange)=\"Pagination.changeSort($event)\"\r\n  (customDbClick)=\"Actions.actionDbClick($event)\"\r\n></dg-data-table>\r\n", styles: [""], components: [{ type: DgDataTableComponent, selector: "dg-data-table", inputs: ["colorLoad", "colorLoadText", "customIconActions", "loading", "message", "dataSource", "showPagination", "columns", "permissions", "entityMapping", "showActions", "actions", "fixedActionColum", "singleAction", "propsActionButton"], outputs: ["customDbClick", "sortChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudDataTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'crud-data-table',
                    templateUrl: './crud-data-table.component.html',
                    styleUrls: ['./crud-data-table.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i1$1.Router }, { type: i1$2.HttpClient }, { type: RegisterCrudTableService }]; }, propDecorators: { entityMap: [{
                type: Input
            }], service: [{
                type: Input
            }], tableEventId: [{
                type: Input
            }], data: [{
                type: Input
            }], selectServerData: [{
                type: Input,
                args: ['select-server-data']
            }], size: [{
                type: Input
            }], sort: [{
                type: Input
            }], showPagination: [{
                type: Input
            }], customActions: [{
                type: Input
            }], singleAction: [{
                type: Input
            }], customDblclick: [{
                type: Input
            }], callbackEdit: [{
                type: Input
            }], propsActionButton: [{
                type: Input
            }], customIconActions: [{
                type: Input,
                args: ['customIconActions']
            }], showDefaultAction: [{
                type: Input
            }], params: [{
                type: Input
            }], persistentParams: [{
                type: Input
            }], endpoint: [{
                type: Input
            }], path: [{
                type: Input
            }], context: [{
                type: Input
            }], contextDelete: [{
                type: Input
            }], server: [{
                type: Input
            }], fetchStart: [{
                type: Input
            }], register: [{
                type: Input
            }], dictionary: [{
                type: Input
            }], resourceDictionary: [{
                type: Input
            }], colorLoad: [{
                type: Input,
                args: ['colorLoad']
            }], colorLoadText: [{
                type: Input,
                args: ['colorLoadText']
            }], loading: [{
                type: Input
            }], callbackMessageEdit: [{
                type: Output
            }], dblclick: [{
                type: Output
            }], pesquisar: [{
                type: HostListener,
                args: ['window:dg-table-atualizar-event', ['$event']]
            }], findByFilters: [{
                type: HostListener,
                args: ['window:dg-table-atualizar-event-filter', ['$event']]
            }], clear: [{
                type: HostListener,
                args: ['window:dg-table-clear-event', ['$event']]
            }] } });

class ClearDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.subscription = new Subscription();
        this.tableEventId = undefined;
    }
    ngOnInit() {
        const el = this.elRef.nativeElement;
        this.subscription = fromEvent(el.parentNode, 'click', { capture: true }).subscribe((e) => {
            if (e.target === el) {
                e.stopPropagation();
                window.dispatchEvent(new CustomEvent('dg-table-filter-clear-event', {
                    detail: this.tableEventId
                }));
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
ClearDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ClearDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ClearDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: ClearDirective, selector: "button[crud-table-clear] , span[crud-table-clear]", inputs: { tableEventId: "tableEventId" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: ClearDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-table-clear] , span[crud-table-clear]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { tableEventId: [{
                type: Input,
                args: ['tableEventId']
            }] } });

/**
 * Esse Sumbol representa as ocorrencias de assinaturas de FILTROS na entidade
 */
const filterFieldKey = Symbol('isFilterColumn');
class DgFilterFieldClass {
    constructor(type, name, colum, resource, mask, declaratResourceMethod, getUrl, data, placeholder, defaultData, propertValue, getServerData, required, position, propertKey, nameParamFilter, nameParamFind, inputFormat, outputFormat, params) {
        this.type = 'text';
        this.colum = '3';
        this.data = [];
        this.defaultData = '';
        this.getServerData = 'never';
        this.type = !!type ? type : 'text';
        this.name = name;
        this.colum = !!colum ? colum : '3';
        this.resource = resource;
        this.mask = mask;
        this.declaratResourceMethod = declaratResourceMethod;
        this.getUrl = getUrl;
        this.data = Array.isArray(data) ? data : [];
        this.placeholder = placeholder;
        this.defaultData = !!defaultData ? defaultData : '';
        this.propertValue = propertValue;
        this.getServerData = !!getServerData ? getServerData : 'never';
        this.required = required;
        this.position = position;
        this.propertKey = propertKey;
        this.nameParamFilter = nameParamFilter;
        this.nameParamFind = nameParamFind;
        this.inputFormat = inputFormat;
        this.outputFormat = outputFormat;
        this.params = params;
    }
}

class CrudFiltersComponent {
    constructor(httpBackup, register) {
        this.httpBackup = httpBackup;
        this.register = register;
        this.formFilters = new FormGroup({});
        this.showButtons = true;
        // emtrega as atualizações ao componente pai para caso ele precise realizar alguma
        // ação secundária na tela de origem com os dados aqui selecionados
        this.dispatchFindFilters = new EventEmitter();
        this.inputLint = [];
        this._where = {};
    }
    ngOnInit() {
        var _a;
        if (!!this.importHttp) {
            this.http = this.importHttp;
        }
        else {
            this.http = this.httpBackup;
        }
        const newInputList = [];
        const newFormFlters = {};
        (_a = this.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.tablefilters.forEach((value, key) => {
            const newInput = Object.assign({ varName: key, _data: Array.isArray(value.data) ? value.data : [] }, new DgFilterFieldClass(value.type, value.name, value.colum, value.resource, value.mask, value.declaratResourceMethod, value.getUrl, value.data, value.placeholder, value.defaultData, value.propertValue, value.getServerData, !!value.required, value.position, value.propertKey, value.nameParamFilter, value.nameParamFind, value.inputFormat, value.outputFormat, value.params));
            let defaultData = value.defaultData;
            if (this.register.verifyFilterExist(this.tableEventId, key)) {
                if (newInput.type == 'autoComplete') {
                    const filter = this.register.getFilters(this.tableEventId || '', key);
                    if (typeof filter == 'string') {
                        defaultData = filter;
                    }
                    else if (typeof filter == "object" && !!newInput.propertValue) {
                        if (newInput.propertValue in filter) {
                            defaultData = filter[newInput.propertValue];
                            newInput.data.push(filter);
                        }
                    }
                }
                else {
                    defaultData = this.register.getFilters(this.tableEventId || '', key);
                }
            }
            newFormFlters[key] = new FormControl(defaultData, (!!value.required ? [Validators.required] : []));
            newInputList.push(newInput);
        });
        this.formFilters = new FormGroup(newFormFlters);
        this.inputLint = newInputList.sort((v1, v2) => {
            if (!v1.position || !v2.position) {
                return 0;
            }
            return v1.position - v2.position;
        });
        if (!this.tableEventId) {
            this.tableEventId = this.entityMap.constructor.name;
        }
        if (!!this.entityMap.configEntityTable.where)
            this._where = this.entityMap.configEntityTable.where;
        this.inputLint.map((input, index) => {
            if (input.getServerData !== 'never') {
                if (input.type === 'select' || input.type === 'autoComplete') {
                    this.getApiAutoComplete(!!input.defaultData ? input.defaultData : '', input, index);
                }
            }
        });
    }
    preparaPesquisar(data) {
        var _a;
        const tableEventId = tableEventKey(String(this.tableEventId), data);
        if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
            return;
        }
        if (this.formFilters.invalid) {
            this.formFilters.markAllAsTouched();
            return;
        }
        let newWhere = {};
        const filterRegister = {};
        Object.keys(this.formFilters.value).map(key => {
            var _a;
            if (this.formFilters.controls[key].valid) {
                if (!!((_a = this.formFilters.controls[key].value) === null || _a === void 0 ? void 0 : _a.trim()) || this.formFilters.controls[key].value == '0') {
                    this.setFilterAutocomplete(key, filterRegister);
                    if (typeof this.formFilters.controls[key].value == 'string') {
                        if (!!this.formFilters.controls[key].value.trim()) {
                            const where = this._getPropertKeySelected(this.formFilters.controls[key].value, key);
                            if (where.resource) {
                                newWhere = Object.assign(Object.assign({}, newWhere), where.value);
                            }
                            else {
                                newWhere = Object.assign(Object.assign({}, newWhere), { [this._getPropertOrParam(key, 'nameParamFind')]: where.value });
                            }
                        }
                    }
                    else if (typeof this.formFilters.controls[key].value == 'number') {
                        if (!!this.formFilters.controls[key].value || this.formFilters.controls[key].value == 0) {
                            const where = this._getPropertKeySelected(this.formFilters.controls[key].value, key);
                            if (where.resource) {
                                newWhere = Object.assign(Object.assign({}, newWhere), where.value);
                            }
                            else {
                                newWhere = Object.assign(Object.assign({}, newWhere), { [this._getPropertOrParam(key, 'nameParamFind')]: where.value });
                            }
                        }
                    }
                }
            }
        });
        this.entityMap.configEntityTable.where = Object.assign(Object.assign({}, this._where), newWhere);
        if (!!((_a = this === null || this === void 0 ? void 0 : this.table) === null || _a === void 0 ? void 0 : _a.register)) {
            this.register.setFilter(this.tableEventId || '', filterRegister);
        }
        this.dispatchFindFilters.emit(this.entityMap.configEntityTable.where);
        window.dispatchEvent(new CustomEvent('dg-table-atualizar-event-filter', {
            detail: this.tableEventId
        }));
    }
    setFilterAutocomplete(key, filterRegister) {
        const index = this.inputLint.findIndex((val) => val.varName == key);
        if (index > -1) {
            if (this.inputLint[index].type == 'autoComplete') {
                const index1 = this.inputLint.findIndex((input) => input.varName == key);
                if (index1 == -1) {
                    return;
                }
                const index2 = this.inputLint[index1].data.findIndex((data) => data[this._getPropertOrParam(key, "propertValue")] == this.formFilters.controls[key].value);
                if (index2 != -1) {
                    filterRegister[key] = {
                        [this._getPropertOrParam(key, 'propertKey')]: this.inputLint[index1].data[index2][this._getPropertOrParam(key, "propertKey")],
                        [this._getPropertOrParam(key, 'propertValue')]: this.formFilters.controls[key].value
                    };
                }
                else {
                    filterRegister[key] = this.formFilters.controls[key].value;
                }
            }
            else {
                filterRegister[key] = this.formFilters.controls[key].value;
            }
        }
    }
    clear(data) {
        var _a;
        this.formFilters.reset('');
        this.entityMap.configEntityTable.where = this._where;
        window.dispatchEvent(new CustomEvent('dg-table-clear-event', {
            detail: this.tableEventId
        }));
        if (!!((_a = this === null || this === void 0 ? void 0 : this.table) === null || _a === void 0 ? void 0 : _a.register)) {
            this.register.clearFilter(this.tableEventId || '');
        }
        this.dispatchFindFilters.emit(this._where);
    }
    selectEvent(index, input) {
        this.formFilters.controls[input.varName].patchValue(this._getPropertSelect(index, input));
    }
    onChangeSearch(val, input, index) {
        if (input.getServerData === 'all') {
            this.getApiAutoComplete(val, input, index);
        }
        else {
            this.autoCompleteDataFix(val, input);
        }
    }
    /**
     * serve para reabrir o dropdown aberto quando for digitada uma alteração
     * @param inputAutoComplete
     * @param ulAutoComplete
     */
    _autoComleteKeyUp(inputAutoComplete, ulAutoComplete) {
        if (!ulAutoComplete.classList.contains('show')) {
            inputAutoComplete.click();
        }
    }
    autoCompleteDataFix(val, input) {
        const newData = [];
        const _data = [...new Set([...input._data, ...input.data])];
        _data.map(d => {
            if (this._clearString(this._extractValueReturnApi(d, input)).match(new RegExp(`${this._clearString(val)}.*$`, 'g'))) {
                newData.push(d);
            }
        });
        input.data = newData;
    }
    /**
     * limpa caracteres especiais para realizar uma comparação válida nos autoCompletes
     * @param str
     */
    _clearString(str) {
        if (typeof str !== "string") {
            return 'error';
        }
        str = str.replace(/a|A|á|Á|â|Â|à|À|ä|Ä|ã|Ã/g, 'a');
        str = str.replace(/e|E|é|É|ê|Ê|è|È|ë|Ë/g, 'e');
        str = str.replace(/i|I|í|Í|î|Î|ì|Ì|ï|Ï/g, 'i');
        str = str.replace(/u|U|ú|Ú|û|Û|ù|Ù|ü|Ü/g, 'u');
        str = str.replace(/o|O|ó|Ó|ô|Ô|ò|Ò|ö|Ö|õ|Õ/g, 'o');
        str = str.replace(/c|C|ç|Ç/g, 'ç');
        return str.toUpperCase();
    }
    /**
     * busca label para input
     * @param input
     */
    _getLabel(input) {
        if (!!input.name) {
            return input.name;
        }
        const result = this._getConfigColumn(input.varName);
        return !!result ? result === null || result === void 0 ? void 0 : result.columnName : '';
    }
    /**
     * com base na varName de filter, busca os dados da tableColumn,
     * útil em casos de reutilização de dados e funções
     * @param name
     */
    _getConfigColumn(name) {
        var _a;
        const configColumn = (_a = this.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.get(name);
        if (!!configColumn) {
            return configColumn;
        }
        return false;
    }
    defauldMask(mask) {
        switch (mask) {
            case 'cpf':
                return '000.000.000-00';
            case 'cnpj':
                return '00.000.000/0000-00';
            case 'cep':
                return '00000-000';
            case 'telefone':
                return '(00) 0000-0000';
            case 'celular':
                return '(00) 0 0000-0000';
            case 'rg':
                return '00.000.000-0';
            case 'conta':
                return '00.000-0';
            case 'egencia':
                return '0000-0';
            case 'cnh':
                return '000000000-00';
            default:
                return !!mask ? mask : '';
        }
    }
    getApiAutoComplete(valueInput, input, index) {
        if (!input.getUrl) {
            throw 'url não informada para filtro autocomplete em ' + this.entityMap.constructor.name;
        }
        let httpParam = new HttpParams();
        if (!!valueInput) {
            httpParam = httpParam.appendAll(Object.assign({ [!!input.nameParamFilter ? input.nameParamFilter : 'nome']: valueInput }, ((input === null || input === void 0 ? void 0 : input.params) ? input.params : {})));
        }
        else {
            httpParam = httpParam.appendAll(Object.assign({}, ((input === null || input === void 0 ? void 0 : input.params) ? input.params : {})));
        }
        console.log(httpParam.get('teste'));
        // debugger
        this.http.get(input.getUrl, { params: httpParam }).subscribe((resp) => {
            this.inputLint[index].data = resp.data;
            if (input.getServerData === 'mount') {
                this.inputLint[index]._data = resp.data;
            }
        });
    }
    _extractValueReturnApi(val, input) {
        if (typeof val === "string") {
            return val;
        }
        if (!!input.propertValue) {
            if (`${input.propertValue}` in val) {
                return val[input.propertValue];
            }
        }
        return 'Erro de comparação';
    }
    /**
     *  retorna os dados para os selects VALUE
     * @param i
     * @param input
     */
    _getPropertSelect(i, input) {
        if (typeof input.data[i] === 'string') {
            return input.data[i];
        }
        if (!!input.propertValue) {
            if (`${input.propertValue}` in input.data[i]) {
                // @ts-ignore
                return input.data[i][input.propertValue];
            }
        }
        return input.data[i];
    }
    // RETORNA OS DADOS SELECIONADOS LEVANDO EM CONSIDERAÇÃO O PROPERTKEY
    _getPropertKeySelected(value, key) {
        const index1 = this.inputLint.findIndex((input) => input.varName == key);
        if (index1 == -1) {
            return { resource: false, value };
        }
        const issetOutputResource = this.inputLint[index1].outputFormat;
        const index2 = this.inputLint[index1].data.findIndex((data) => data[this._getPropertOrParam(key, "propertValue")] == value);
        if (index2 == -1) {
            return !!issetOutputResource ? { resource: true, value: issetOutputResource(value) } : { resource: false, value };
        }
        if (!this.inputLint[index1].data[index2][this._getPropertOrParam(key, "propertKey")]) {
            return !!issetOutputResource ? {
                resource: true,
                value: issetOutputResource(value, this.inputLint[index1].data[index2])
            }
                : { resource: false, value };
        }
        return !!issetOutputResource
            ? {
                resource: true,
                value: issetOutputResource(this.inputLint[index1].data[index2][this._getPropertOrParam(key, "propertKey")], this.inputLint[index1].data[index2])
            }
            : {
                resource: false,
                value: this.inputLint[index1].data[index2][this._getPropertOrParam(key, "propertKey")]
            };
    }
    // metodo de apoiio aos outros metodos que buscam os campos do input.
    _getPropertOrParam(key, type) {
        const index = this.inputLint.findIndex((input) => input.varName == key);
        if (index == -1 || !this.inputLint[index][type]) {
            return key;
        }
        return this.inputLint[index][type];
    }
}
CrudFiltersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudFiltersComponent, deps: [{ token: i1$2.HttpClient }, { token: RegisterCrudTableService }], target: i0.ɵɵFactoryTarget.Component });
CrudFiltersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CrudFiltersComponent, selector: "crud-filters", inputs: { tableEventId: "tableEventId", service: "service", entityMap: "entityMap", showButtons: "showButtons", table: "table", importHttp: ["http", "importHttp"] }, outputs: { dispatchFindFilters: "dispatchFindFilters" }, host: { listeners: { "window:dg-table-find-filter-event": "preparaPesquisar($event)", "window:dg-table-filter-clear-event": "clear($event)" } }, ngImport: i0, template: "<div class=\"crud-filter-root container-fluid\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <form [formGroup]=\"formFilters\">\r\n        <div class=\"row\">\r\n          <div\r\n            *ngFor=\"let input of inputLint; let index = index\"\r\n            class=\"col-xl-{{input.colum}} col-lg-{{input.colum}} col-md-{{input.colum}} col-sm-12\"\r\n          >\r\n            <label for=\"{{input.varName}}\" class=\"form-label\">{{_getLabel(input)}}</label>\r\n\r\n            <input\r\n              *ngIf=\"(input.type !== 'select' && input.type !== 'autoComplete')\"\r\n              type=\"{{(!!input.type ? input.type : 'text')}}\"\r\n              [formControlName]=\"input.varName\"\r\n              class=\"form-control\"\r\n              id=\"{{input.varName}}\"\r\n              placeholder=\"{{input.placeholder}}\"\r\n              [mask]=\"defauldMask(input.mask)\"\r\n            >\r\n\r\n            <div class=\"autocomplete\" *ngIf=\"input.type === 'autoComplete'\">\r\n              <input\r\n                #inputAutoComplete\r\n                tabindex=\"-1\"\r\n                [formControlName]=\"input.varName\"\r\n                (ngModelChange)=\"onChangeSearch($event, input, index)\"\r\n                (keyup)=\"_autoComleteKeyUp(inputAutoComplete, ulAutoComplete)\"\r\n                class=\"form-control dropdown-toggle\"\r\n                type=\"text\"\r\n                autocomplete=\"off\"\r\n                placeholder=\"{{input.placeholder}}\"\r\n                id=\"autocomplete-filter-{{index}}\"\r\n                data-bs-toggle=\"dropdown\"\r\n                aria-expanded=\"false\"\r\n              >\r\n\r\n              <ul\r\n                #ulAutoComplete\r\n                id=\"inputTesteMenu\"\r\n                class=\"dropdown-menu\"\r\n                style=\"z-index: 1002 !important;\"\r\n                [attr.aria-labelledby]=\"'autocomplete-filter-' + index\"\r\n              >\r\n                <li\r\n                  *ngFor=\"let option of input.data; let i = index\"\r\n                  class=\"crud-filter-autocomplete\"\r\n                  (click)=\"selectEvent(i, input)\"\r\n                  [value]=\"option.value\"\r\n                >\r\n                  <span class=\"dropdown-item\">\r\n                    {{\r\n                    !!input.mask ? (_getPropertSelect(i, input) | mask: defauldMask(input.mask)) : _getPropertSelect(i, input)\r\n                    }}\r\n                  </span>\r\n                </li>\r\n\r\n                <li *ngIf=\"input.data.length == 0\">\r\n                  <span class=\"dropdown-item\">\r\n                    Nenhum registro encontrado\r\n                  </span>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n            <select\r\n              data-live-search=\"true\"\r\n              *ngIf=\"input.type === 'select'\"\r\n              class=\"form-control\"\r\n              [formControlName]=\"input.varName\"\r\n            >\r\n              <option\r\n                *ngFor=\"let option of input.data; let i = index\"\r\n                [value]=\"_getPropertSelect(i, input)\"\r\n              >\r\n                {{\r\n                !!input.mask ? (_getPropertSelect(i, input) | mask: defauldMask(input.mask)) : _getPropertSelect(i, input)\r\n                }}\r\n              </option>\r\n\r\n            </select>\r\n\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\" *ngIf=\"showButtons\">\r\n    <div class=\"col-12 crud-filters-row-btn\">\r\n      <button (click)=\"preparaPesquisar(tableEventId || table?.tableEventId)\" class=\"btn btn-sm btn-success\">Pesquisar</button>\r\n      <button (click)=\"clear()\" class=\"btn btn-sm btn-secondary\">Limpar</button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".crud-filter-autocomplete{cursor:pointer}.crud-filter-root{max-width:100%}.crud-filter-autocomplete:hover{background:#9a9797}.crud-filters-row-btn{margin:1rem auto;display:inline-flex;justify-content:center}.crud-filters-row-btn button{margin:auto .3rem}\n"], directives: [{ type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5$1.MaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "mask": i5$1.MaskPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudFiltersComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'crud-filters',
                    templateUrl: './crud-filters.component.html',
                    styleUrls: ['./crud-filters.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: RegisterCrudTableService }]; }, propDecorators: { tableEventId: [{
                type: Input
            }], service: [{
                type: Input
            }], entityMap: [{
                type: Input
            }], showButtons: [{
                type: Input
            }], table: [{
                type: Input
            }], importHttp: [{
                type: Input,
                args: ['http']
            }], dispatchFindFilters: [{
                type: Output,
                args: ['dispatchFindFilters']
            }], preparaPesquisar: [{
                type: HostListener,
                args: ['window:dg-table-find-filter-event', ['$event']]
            }], clear: [{
                type: HostListener,
                args: ['window:dg-table-filter-clear-event', ['$event']]
            }] } });

class FindFiltersDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.subscription = new Subscription();
        this.tableEventId = undefined;
    }
    ngOnInit() {
        const el = this.elRef.nativeElement;
        this.subscription = fromEvent(el.parentNode, 'click', { capture: true }).subscribe((e) => {
            if (e.target === el) {
                e.stopPropagation();
                window.dispatchEvent(new CustomEvent('dg-table-find-filter-event', {
                    detail: this.tableEventId
                }));
            }
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
FindFiltersDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FindFiltersDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FindFiltersDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.1.5", type: FindFiltersDirective, selector: "button[crud-find-filters] , span[crud-find-filters]", inputs: { tableEventId: "tableEventId" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: FindFiltersDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[crud-find-filters] , span[crud-find-filters]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { tableEventId: [{
                type: Input,
                args: ['tableEventId']
            }] } });

class CrudTableArrayComponent {
    constructor(injector) {
        this.injector = injector;
        // lista de registros apresentados na tabela
        this.dataSource = [];
        // fixar coluna de ações
        this.fixedActionColum = false;
        // AÇÕES PADRÃO
        this.defaultActions = [
            { name: 'Editar', action: (row) => this.executEditar(row), permission: true },
            { name: 'Excluir', action: (row) => this.executExcluir(row), permission: true }
        ];
        this.data = [];
        /**
         * INPUTS referentes a PAGINAÇÃO
         */
        this.size = undefined;
        this.sort = 'id,asc';
        this._sort = '';
        this.showPagination = false;
        this.path = '';
        this.context = '';
        this.contextDelete = undefined;
        this.customIconActions = 'more_vert';
        this.colorLoad = '#69aff5';
        this.colorLoadText = 'black';
        this.loading = true;
        this.showDefaultAction = true;
        this.customDblclick = false;
        this.callbackEdit = true;
        this.callbackMessageEdit = new EventEmitter();
        this.dblclick = new EventEmitter();
        this.editar = new EventEmitter();
        this.excluir = new EventEmitter();
    }
    ngOnInit() {
        var _a;
        // criando colunas
        if (!this.columns) {
            this.columns = [];
            (_a = this.entityMap.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.forEach((value, key) => {
                var _a;
                let column = {
                    header: value.columnName,
                    varName: key,
                };
                if (!!value.resource)
                    column.resource = value.resource;
                if (!!value.mask)
                    column.mask = value.mask;
                if (!!value.width)
                    column.width = value.width;
                if (value.declaratResourceMethod)
                    column.declaratResourceMethod = value.declaratResourceMethod;
                if (value.fixedColumnEnd)
                    column.fixedColumnEnd = value.fixedColumnEnd;
                if (value.fixedColumnStart)
                    column.fixedColumnStart = value.fixedColumnStart;
                if (value.sort)
                    column.sort = value.sort;
                column.columnClassName = value.columnClassName;
                (_a = this.columns) === null || _a === void 0 ? void 0 : _a.push(column);
            });
        }
        this._verify_actions();
        if (!this.tableEventId) {
            this.tableEventId = this.entityMap.constructor.name;
        }
        if (!!this.data) {
            this._pesquisar();
        }
    }
    ngOnChanges(changes) {
        var _a;
        if ('data' in changes) {
            // if (changes.data.previousValue?.length == 0) {
            if (((_a = changes.data.currentValue) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this._pesquisar();
            }
            // }
        }
    }
    _pesquisar() {
        this.loading = false;
        this.dataSource = [];
        setTimeout(() => this.dataSource = this.data, 10);
    }
    /**
     * RECEPTORES DE EVENTOS
     */
    // BUSCAR DADOS
    pesquisar(data) {
        var _a;
        const tableEventId = tableEventKey(String(this.tableEventId), data);
        if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
            return;
        }
        if (!!this.service) {
            this.service.removeParams('findAll', ['page']);
        }
        if ((_a = this.entityMap.configEntityTable.pagination) === null || _a === void 0 ? void 0 : _a.page) {
            this.entityMap.configEntityTable.pagination.page = 0;
        }
        this._pesquisar();
    }
    // LIMPAR FILTROS DE PAGINAÇÃO
    clear(data) {
        // if (!this.entityMap?.configEntityTable?.pagination?.sort) {
        //   return;
        // }
        //
        // const tableEventId = tableEventKey(String(this.tableEventId), data)
        //
        // if (this.tableEventId != tableEventId && tableEventId !== 'all_tables') {
        //   return;
        // }
        //
        // if (!!this.service) {
        //   const findAll = <httpServiceInterface>this.service.endpoints.get('findAll');
        //
        //   if (!!findAll) {
        //     findAll['params'] = {};
        //   }
        //   this.service.endpoints.set('findAll', findAll)
        // }
        //
        // if (this.entityMap.configEntityTable?.pagination?.page) {
        //   this.entityMap.configEntityTable.pagination.page = 0;
        // }
        //
        // if (this.sort !== null) {
        //   this.entityMap.configEntityTable.pagination.sort = this.sort;
        // } else {
        //   if (!!this.service) {
        //     this.service.removeParams('findAll', ['sort'])
        //   }
        // }
        //
        // this._pesquisar();
    }
    /**
     * METODOS DE AÇÃO DA TABELA
     */
    // Verificando as actions
    _verify_actions() {
        var _a, _b, _c, _d;
        // BUSCA POR SERVICE ACTION
        if ((_a = this.entityMap) === null || _a === void 0 ? void 0 : _a.serviceAction) {
            // instancia actionsService
            this.ActionService = this.injector.get(this.entityMap.serviceAction);
            // verifica fixed service
            this.fixedActionColum = this.ActionService.fixedColumnActions;
            if (typeof this.showDefaultAction === 'boolean' && this.showDefaultAction) {
                this.cunstomAction = this._insert_actions(this.defaultActions, this.ActionService.list());
                if (Array.isArray((_b = this.entityMap.configEntityTable) === null || _b === void 0 ? void 0 : _b.customActions)) {
                    this.cunstomAction = this._insert_actions(this.cunstomAction, (_c = this.entityMap.configEntityTable) === null || _c === void 0 ? void 0 : _c.customActions);
                }
            }
            else if (typeof this.showDefaultAction === 'string') {
                if (this.showDefaultAction === 'editar') {
                    this.cunstomAction = [
                        this.defaultActions[0],
                        ...this.ActionService.list()
                    ];
                }
                else {
                    this.cunstomAction = [
                        this.defaultActions[1],
                        ...this.ActionService.list()
                    ];
                }
            }
            else {
                this.cunstomAction = this.ActionService.list();
            }
        }
        // BUSCA POR CUSTOM ACTIONS
        else if (Array.isArray((_d = this.entityMap.configEntityTable) === null || _d === void 0 ? void 0 : _d.customActions)) {
            this.cunstomAction = this._insert_actions(this.defaultActions, this.entityMap.configEntityTable.customActions);
        }
        // BUSCA POR DEFAULT ACTION
        else if (typeof this.showDefaultAction === 'string') {
            if (this.showDefaultAction === 'editar') {
                this.cunstomAction = [this.defaultActions[0]];
            }
            else {
                this.cunstomAction = [this.defaultActions[1]];
            }
        }
        // VERIFICA DEFAULT ACTIONS
        else if (this.showDefaultAction) {
            this.cunstomAction = this.defaultActions;
        }
    }
    //inserindo actions e subscrevendo metodos repetidos com base no nome
    _insert_actions(defaultActions, customActions) {
        const result = defaultActions;
        customActions.map((filter) => {
            const indexDefaultAction = defaultActions.findIndex((defAction) => defAction.name.toUpperCase() == filter.name.toUpperCase());
            if (indexDefaultAction != -1) {
                result.splice(indexDefaultAction, 1, filter);
            }
            else {
                result.push(filter);
            }
        });
        return result;
    }
    actionDbClick(element) {
        if (this.customDblclick) {
            this.dblclick.emit(element);
        }
        else if (this.editar === null) {
            return;
        }
        else {
            const index = this.defaultActions.findIndex(action => action.name.toUpperCase() == 'EDITAR');
            if (index != -1) {
                this.defaultActions[index].action(element);
            }
        }
    }
    executEditar(element) {
        this.editar.emit(element);
    }
    executExcluir(row) {
        Swal.fire({
            title: 'Excluir registro',
            text: "Deseja excluir este registro? Esta ação é permanente.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Deletar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.excluir.emit(row);
            }
        });
    }
}
CrudTableArrayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudTableArrayComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
CrudTableArrayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CrudTableArrayComponent, selector: "crud-table-array", inputs: { data: "data", tableEventId: "tableEventId", size: "size", sort: "sort", showPagination: "showPagination", params: "params", persistentParams: "persistentParams", endpoint: "endpoint", path: "path", context: "context", contextDelete: "contextDelete", server: "server", entityMap: "entityMap", dictionary: "dictionary", customIconActions: "customIconActions", colorLoad: "colorLoad", colorLoadText: "colorLoadText", loading: "loading", showDefaultAction: "showDefaultAction", service: "service", customDblclick: "customDblclick", callbackEdit: "callbackEdit", propsActionButton: "propsActionButton", customAction: "customAction", resourceDictionary: "resourceDictionary", columns: "columns" }, outputs: { callbackMessageEdit: "callbackMessageEdit", dblclick: "dblclick", editar: "editar", excluir: "excluir" }, host: { listeners: { "window:dg-table-atualizar-event": "pesquisar($event)", "window:dg-table-clear-event": "clear($event)" } }, usesOnChanges: true, ngImport: i0, template: "<dg-data-table\r\n  class=\"generic-crudTable-key\"\r\n  [columns]=\"columns || []\"\r\n  [actions]=\"cunstomAction\"\r\n  [entityMapping]=\"entityMap\"\r\n  [dataSource]=\"dataSource\"\r\n  [showPagination]=\"(showPagination && !!entityMap?.configEntityTable?.pagination)\"\r\n  [loading]=\"loading\"\r\n  [customIconActions]=\"customIconActions\"\r\n  [fixedActionColum]=\"fixedActionColum\"\r\n  [propsActionButton]=\"propsActionButton\"\r\n  [singleAction]=\"customAction\"\r\n  (customDbClick)=\"actionDbClick($event)\"\r\n></dg-data-table>\r\n", styles: [""], components: [{ type: DgDataTableComponent, selector: "dg-data-table", inputs: ["colorLoad", "colorLoadText", "customIconActions", "loading", "message", "dataSource", "showPagination", "columns", "permissions", "entityMapping", "showActions", "actions", "fixedActionColum", "singleAction", "propsActionButton"], outputs: ["customDbClick", "sortChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudTableArrayComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'crud-table-array',
                    templateUrl: './crud-table-array.component.html',
                    styleUrls: ['./crud-table-array.component.css']
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { data: [{
                type: Input
            }], tableEventId: [{
                type: Input
            }], size: [{
                type: Input
            }], sort: [{
                type: Input
            }], showPagination: [{
                type: Input
            }], params: [{
                type: Input
            }], persistentParams: [{
                type: Input
            }], endpoint: [{
                type: Input
            }], path: [{
                type: Input
            }], context: [{
                type: Input
            }], contextDelete: [{
                type: Input
            }], server: [{
                type: Input
            }], entityMap: [{
                type: Input
            }], dictionary: [{
                type: Input
            }], customIconActions: [{
                type: Input,
                args: ['customIconActions']
            }], colorLoad: [{
                type: Input,
                args: ['colorLoad']
            }], colorLoadText: [{
                type: Input,
                args: ['colorLoadText']
            }], loading: [{
                type: Input
            }], showDefaultAction: [{
                type: Input
            }], service: [{
                type: Input
            }], customDblclick: [{
                type: Input
            }], callbackEdit: [{
                type: Input
            }], propsActionButton: [{
                type: Input
            }], customAction: [{
                type: Input
            }], resourceDictionary: [{
                type: Input
            }], callbackMessageEdit: [{
                type: Output
            }], dblclick: [{
                type: Output
            }], editar: [{
                type: Output
            }], excluir: [{
                type: Output
            }], columns: [{
                type: Input
            }], pesquisar: [{
                type: HostListener,
                args: ['window:dg-table-atualizar-event', ['$event']]
            }], clear: [{
                type: HostListener,
                args: ['window:dg-table-clear-event', ['$event']]
            }] } });

class CrudPaginationComponent {
    constructor() {
        this.optionsSizesPagination = [5, 10, 20, 50, 100];
        this.showSizeSelect = true;
        this.changePage = new EventEmitter();
        this.currentPage = 1;
        this.data = {
            size: 10,
            page: 0,
            totalPages: 0
        };
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes['dataPagination']) {
            const dataPagination = changes['dataPagination'].currentValue;
            this.data.page = (!!(dataPagination === null || dataPagination === void 0 ? void 0 : dataPagination.page) && dataPagination.page != 0) ? Number(dataPagination.page) : 0;
            this.data.size = (!!(dataPagination === null || dataPagination === void 0 ? void 0 : dataPagination.size) && dataPagination.size != 0) ? Number(dataPagination.size) : 10;
            this.data.totalPages = (!!(dataPagination === null || dataPagination === void 0 ? void 0 : dataPagination.totalPages) && dataPagination.totalPages != 0) ? Number(dataPagination.totalPages) : 0;
        }
    }
    changePagination(value) {
        this.data.page = value;
        this.changePage.emit(this.data);
    }
    verificarMenores(value) {
        return ((Number(this.data.page) + 1) - value) > 0;
    }
    disabled(data, valor) {
        if (data === 'menos') {
            if (!!valor) {
                return (this.data.page - valor) < 0;
            }
            else {
                return this.data.page <= 0;
            }
        }
        else {
            if (!!valor) {
                return Number(this.data.page) + valor >= this.data.totalPages;
            }
            else {
                return Number(this.data.page) + 1 >= this.data.totalPages;
            }
        }
    }
    verificarMaiores(value) {
        return ((Number(this.data.page) + 1) + value) <= this.data.totalPages;
    }
    alterSize(size) {
        this.data.page = 0;
        this.data.size = size;
        this.changePage.emit(this.data);
    }
}
CrudPaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CrudPaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: CrudPaginationComponent, selector: "crud-pagination", inputs: { table: "table", entity: "entity", dataPagination: "dataPagination", optionsSizesPagination: "optionsSizesPagination", showSizeSelect: "showSizeSelect" }, outputs: { changePage: "changePage" }, usesOnChanges: true, ngImport: i0, template: "<nav class=\"dg-pagination\">\r\n  <ul class=\"pagination\">\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos', 2) ? null : changePagination(0)\"\r\n      [class.disabled]=\"disabled('menos', 2)\"\r\n    >\r\n      <span class=\"page-link\"> << </span>\r\n    </li>\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos') ? null : changePagination(data.page - 1)\"\r\n      [class.disabled]=\"disabled('menos')\"\r\n    >\r\n      <span class=\"page-link\"> < </span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" (click)=\"changePagination(data.page + - 2)\" *ngIf=\"verificarMenores(2)\">\r\n      <span class=\"page-link\" href=\"#\">{{  data.page - 1 }}</span>\r\n    </li>\r\n\r\n    <li class=\"page-item\" (click)=\"changePagination(data.page + - 1)\" *ngIf=\"verificarMenores(1)\">\r\n      <span class=\"page-link\" href=\"#\">{{ data.page }}</span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item active-pagination\">\r\n      <span class=\"page-link\">{{ (data.page + 1) }}</span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(1)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(data.page + 1)\">{{ (data.page + 2) }}</span>\r\n    </li>\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(2)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(data.page + 2)\">{{ (data.page + 3) }}</span>\r\n    </li>\r\n\r\n    <!--    <li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>-->\r\n\r\n\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais') ? null : changePagination(data.page + 1)\"\r\n      [class.disabled]=\"disabled('mais')\"\r\n    >\r\n      <span class=\"page-link\"> > </span>\r\n    </li>\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais', 2) ? null : changePagination(data.totalPages - 1)\"\r\n      [class.disabled]=\"disabled('mais', 2)\"\r\n    >\r\n      <span class=\"page-link\"> >> </span>\r\n    </li>\r\n  </ul>\r\n\r\n  <ul *ngIf=\"showSizeSelect\" class=\"pagination size\" style=\"margin-left: .5rem\">\r\n    <li class=\"page-item\">\r\n      <select class=\"page-link h-100\" [(ngModel)]=\"data.size\" (ngModelChange)=\"alterSize($event)\">\r\n        <option *ngFor=\"let option of optionsSizesPagination\" [value]=\"option\">{{option}}</option>\r\n      </select>\r\n    </li>\r\n\r\n    <li class=\"page-item\">\r\n      <span class=\"page-link\">\r\n        P\u00E1gina {{data.page + 1}} de {{data.totalPages}}\r\n      </span>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n", styles: [".dg-pagination{display:inline-flex}.dg-pagination.page-item:not(.active-pagination,.disabled){cursor:pointer}.dg-pagination li{cursor:pointer}.dg-pagination li.disabled{opacity:60%;cursor:default}.dg-pagination li.page-link{color:#9a9797}.dg-pagination li.page-item.active-pagination,.dg-pagination li.page-item.active-pagination .page-link{cursor:default;color:#fff!important;font-weight:bold;background-color:#9a9797;border-radius:2px}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudPaginationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'crud-pagination',
                    templateUrl: './crud-pagination.component.html',
                    styleUrls: ['./crud-pagination.component.css']
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { table: [{
                type: Input,
                args: ['table']
            }], entity: [{
                type: Input,
                args: ['entity']
            }], dataPagination: [{
                type: Input
            }], optionsSizesPagination: [{
                type: Input
            }], showSizeSelect: [{
                type: Input
            }], changePage: [{
                type: Output
            }] } });

const maskConfigFunction = () => {
    return {
        validation: false,
        decimalMarker: ',',
        thousandSeparator: '.'
    };
};
class DgCrudModule {
}
DgCrudModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgCrudModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgCrudModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgCrudModule, declarations: [DeletarDirective,
        AdicionarDirective,
        VoltarDirective,
        SalvarDirective,
        CrudDataTableComponent,
        DgDataTableComponent,
        LoadingTableComponent,
        ClearDirective,
        CrudFiltersComponent,
        FindFiltersDirective,
        CrudTableArrayComponent,
        CrudPaginationComponent], imports: [MatTableModule, i5$1.NgxMaskModule, MatButtonModule,
        MatMenuModule,
        MatIconModule,
        RouterModule,
        CommonModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        FormsModule], exports: [DeletarDirective,
        AdicionarDirective,
        VoltarDirective,
        SalvarDirective,
        CrudDataTableComponent,
        DgDataTableComponent,
        CrudFiltersComponent,
        ClearDirective,
        FindFiltersDirective,
        CrudTableArrayComponent] });
DgCrudModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgCrudModule, providers: [HttpClient], imports: [[
            MatTableModule,
            NgxMaskModule.forRoot(maskConfigFunction),
            MatButtonModule,
            MatMenuModule,
            MatIconModule,
            RouterModule,
            CommonModule,
            MatPaginatorModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: DgCrudModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DeletarDirective,
                        AdicionarDirective,
                        VoltarDirective,
                        SalvarDirective,
                        CrudDataTableComponent,
                        DgDataTableComponent,
                        LoadingTableComponent,
                        ClearDirective,
                        CrudFiltersComponent,
                        FindFiltersDirective,
                        CrudTableArrayComponent,
                        CrudPaginationComponent
                    ],
                    providers: [HttpClient],
                    imports: [
                        MatTableModule,
                        NgxMaskModule.forRoot(maskConfigFunction),
                        MatButtonModule,
                        MatMenuModule,
                        MatIconModule,
                        RouterModule,
                        CommonModule,
                        MatPaginatorModule,
                        ReactiveFormsModule,
                        FormsModule
                    ],
                    exports: [
                        DeletarDirective,
                        AdicionarDirective,
                        VoltarDirective,
                        SalvarDirective,
                        CrudDataTableComponent,
                        DgDataTableComponent,
                        CrudFiltersComponent,
                        ClearDirective,
                        FindFiltersDirective,
                        CrudTableArrayComponent
                    ],
                }]
        }] });

class AbstractActionsTableService {
    constructor() {
        /**
         * Atributo controlador de 'fixed' da coluna de ações da tabela
         * Caso selecionado, esse metodo irá fixar a coluna e incluir a
         * classe table-colum-fixed
         */
        this.fixedColumnActions = false;
    }
    /**
     * Lista de ações da tabela
     */
    list() {
        return [];
    }
}

class AbstractRootEntity {
}

/**
 * Esse Sumbol representa as ocorrencias de assinaturas de COLUNAS na entidade
 */
const tableColumnKey = Symbol('isTableColumn');
class DgTableColumnClass {
    constructor(data) {
        this.columnName = data.columnName;
        this.resource = data.resource;
        this.mask = data.mask;
        this.declaratResourceMethod = data.declaratResourceMethod;
        this.columnClassName = !!data.columnClassName ? data.columnClassName : '';
        this.width = data.width;
        this.fixedColumnEnd = !!data.fixedColumnEnd;
        this.fixedColumnStart = !!data.fixedColumnStart;
        this.sort = !!data.sort;
    }
}

/**
 *
 * @param key
 * @param origin
 */
function getFilteredProperties(key, origin) {
    return Reflect.getMetadata(key, origin);
}
class AbstractEntity extends AbstractRootEntity {
    constructor() {
        var _a, _b;
        super();
        /**
         * Atributo de configuração dos dados dinâmicos da tabela
         */
        this.configEntityTable = {
            tableColumns: new Map(),
            tablefilters: new Map(),
            pagination: {
                size: 10,
                page: 0,
                sort: 'id,asc'
            }
        };
        this.setPagination = (pagination) => {
            if (pagination !== null) {
                this.configEntityTable.pagination = Object.assign(Object.assign({}, this.configEntityTable.pagination), { size: !!(pagination === null || pagination === void 0 ? void 0 : pagination.size) ? pagination.size : 10, page: !!(pagination === null || pagination === void 0 ? void 0 : pagination.page) ? pagination.page : 0, sort: ((!!(pagination === null || pagination === void 0 ? void 0 : pagination.sortField) ? pagination.sortField : 'id') + ','
                        + (!!(pagination === null || pagination === void 0 ? void 0 : pagination.sortDirection) ? pagination.sortDirection : 'asc')) });
            }
            else {
                this.configEntityTable.pagination = undefined;
            }
        };
        this.addColumns = (columns) => {
            columns.map(colunm => {
                var _a, _b;
                let { nameAtributo, preserveAttributes } = colunm, colun = __rest(colunm, ["nameAtributo", "preserveAttributes"]);
                if (preserveAttributes) {
                    const colunmPart = Object.assign(Object.assign({}, this.configEntityTable.tableColumns.get(nameAtributo)), colunm);
                    (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.set(nameAtributo, new DgTableColumnClass(Object.assign({}, colunmPart)));
                }
                else {
                    (_b = this.configEntityTable) === null || _b === void 0 ? void 0 : _b.tableColumns.set(nameAtributo, new DgTableColumnClass(Object.assign({}, colun)));
                }
            });
        };
        this.addFilters = (filters) => {
            filters.map(filt => {
                var _a, _b;
                let { nameAtributo, preserveAttributes } = filt, filter = __rest(filt, ["nameAtributo", "preserveAttributes"]);
                if (preserveAttributes) {
                    const filterPart = Object.assign(Object.assign({}, this.configEntityTable.tablefilters.get(nameAtributo)), filter);
                    (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tablefilters.set(nameAtributo, Object.assign({}, filterPart));
                }
                else {
                    (_b = this.configEntityTable) === null || _b === void 0 ? void 0 : _b.tablefilters.set(nameAtributo, Object.assign({}, filter));
                }
            });
        };
        this.removeFilters = (filters) => {
            filters.map(filter => {
                var _a;
                (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tablefilters.forEach((DgFilyerFieldClass, nomeAtributo, q) => {
                    var _a;
                    if (nomeAtributo === filter) {
                        (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tablefilters.delete(nomeAtributo);
                    }
                });
            });
        };
        this.removeColumns = (columns) => {
            columns.map(colunm => {
                var _a;
                (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.forEach((DgTableColumnClass, nomeAtributo, q) => {
                    var _a;
                    if (nomeAtributo === colunm) {
                        (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns.delete(nomeAtributo);
                    }
                });
            });
        };
        this.addActions = (actions) => {
            this.configEntityTable.customActions = actions;
        };
        this.addTableParams = (where) => {
            this.configEntityTable.where = where;
        };
        let tableColunms = getFilteredProperties(tableColumnKey, this);
        let tablefilters = getFilteredProperties(filterFieldKey, this);
        // @ts-ignore
        (_a = this.configEntityTable) === null || _a === void 0 ? void 0 : _a.tableColumns = !!tableColunms ? tableColunms : new Map();
        // @ts-ignore
        (_b = this.configEntityTable) === null || _b === void 0 ? void 0 : _b.tablefilters = !!tablefilters ? tablefilters : new Map();
    }
}

class AbstractHttpService {
    constructor(
    // Arquivo de configuração do Abstract Service
    _http, _path = '', context = '') {
        this._http = _http;
        this._path = _path;
        this.context = context;
        this.endpoints = new Map();
        /**
         * @deprecated
         * anteriormente chamado de RESOURCE, agora esse atributo tem o nome de CONTEXT
         * isso ocorre para melhor adaptação com o HttpClient padrão do angular, onde o valor
         * CONTEXT existe nesse mesmo sentido
         */
        this.resource = '';
        /**
         * @deprecated
         */
        this.dictionary = {
            findAll: undefined,
            findOne: undefined,
            save: undefined,
            update: undefined
        };
        if (!_http) {
            throw 'ConfigDgCrudService não informado';
        }
        if (_http instanceof HttpClient) {
            this.http = _http;
        }
        else {
            this.http = _http.http;
        }
        // if (!configLibs?.http && !(configLibs instanceof HttpClient)) {
        //   throw 'http: HttpClient não foi informado'
        // }
        this.resource = context;
        // this.http = configLibs?.http || configLibs;
        this.path = context ? `${_path}${context}` : context;
        this.initService();
    }
    initService(d) {
        //@ts-ignore
        const data = (d instanceof AbstractEntity) ? d.dataServer : d;
        this.endpoints.set('findAll', {
            method: 'GET',
            path: (data === null || data === void 0 ? void 0 : data.path) || this._path,
            context: (data === null || data === void 0 ? void 0 : data.context) || this.context,
            params: {
                size: 10, page: 0, sort: 'id,desc'
            }
        });
        this.endpoints.set('findOne', {
            method: 'GET',
            path: (data === null || data === void 0 ? void 0 : data.path) || this._path,
            context: (data === null || data === void 0 ? void 0 : data.context) || this.context
        });
        this.endpoints.set('update', {
            method: 'PUT',
            path: (data === null || data === void 0 ? void 0 : data.path) || this._path,
            context: (data === null || data === void 0 ? void 0 : data.context) || this.context
        });
        this.endpoints.set('save', {
            method: 'POST',
            path: (data === null || data === void 0 ? void 0 : data.path) || this._path,
            context: (data === null || data === void 0 ? void 0 : data.context) || this.context
        });
        this.endpoints.set('deleteOne', {
            method: 'DELETE',
            path: (data === null || data === void 0 ? void 0 : data.path) || this._path,
            context: (data === null || data === void 0 ? void 0 : data.context) || this.context
        });
    }
    /****************************************
     *  METODOS DE MANUTENÇÃO DOS ENDPOINTS
     ***************************************/
    editEndpointAll(data) {
        [...this.endpoints.keys()].map((keyEndpoint) => {
            this.editEndpoint(keyEndpoint, Object.assign({}, data));
        });
    }
    editEndpoint(name, data) {
        if (!this.endpoints.get(name))
            throw 'endpoint não encontrado';
        if (!!data) {
            const endpoint = this.endpoints.get(name);
            this.endpoints.set(name, Object.assign(Object.assign({}, endpoint), data));
        }
        return {
            addParams: (data) => this.addParams(name, data),
            removeParams: (data) => this.removeParams(name, data),
            addPartialContext: (data) => this.addPartialContext(name, data),
            removePartialContext: (data) => this.removePartialContext(name, data),
            addHeaders: (data) => this.addHeaders(name, data),
            removeHeaders: (data) => this.removeHeaders(name, data),
        };
    }
    addParams(name, params) {
        const endpoint = this.endpoints.get(name);
        endpoint.params = Object.assign(Object.assign({}, endpoint.params), params);
    }
    removeParams(name, params) {
        const endpoint = this.endpoints.get(name);
        if (!!endpoint.params) {
            params.map(param => {
                if (!!endpoint.params) {
                    if (param in endpoint.params) {
                        //@ts-ignore
                        delete endpoint.params[param];
                    }
                }
            });
            this.endpoints.set(name, endpoint);
        }
    }
    addHeaders(name, headers) {
        const endpoint = this.endpoints.get(name);
        endpoint.headers = Object.assign(Object.assign({}, endpoint.headers), headers);
    }
    removeHeaders(name, headers) {
        const endpoint = this.endpoints.get(name);
        if (!!endpoint.headers) {
            headers.map(header => {
                if (!!endpoint.params) {
                    // @ts-ignore
                    if (header in endpoint.headers) {
                        //@ts-ignore
                        delete endpoint.headers[param];
                    }
                }
            });
        }
    }
    addPartialContext(name, endpointUrl) {
        const endpoint = this.endpoints.get(name);
        const persist = !!endpoint.endpoint ? endpoint.endpoint : [];
        endpoint.endpoint = [
            ...persist,
            ...endpointUrl
        ];
        this.endpoints.set(name, endpoint);
    }
    removePartialContext(name, endpointUrl) {
        const endpoint = this.endpoints.get(name);
        if (!!endpoint.endpoint) {
            // @ts-ignore
            endpointUrl.map((url) => {
                var _a, _b;
                const index = (_a = endpoint.endpoint) === null || _a === void 0 ? void 0 : _a.findIndex(endUrl => url == endUrl);
                if (index === -1) {
                    return false;
                }
                // @ts-ignore
                (_b = endpoint.endpoint) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
            });
        }
    }
    /****************************************
     *  METODOS DE OPERAÇÕES ABSTRAÍDAS
     ***************************************/
    _resolveFetch(endpoint, data) {
        switch (endpoint.method) {
            case "GET":
                return this.http.get(this._resolveEndpointUrl(endpoint), Object.assign({}, this._resolveParams(endpoint)));
            case "POST":
                return this.http.post(this._resolveEndpointUrl(endpoint), data, Object.assign({}, this._resolveParams(endpoint)));
            case "PUT":
                return this.http.put(this._resolveEndpointUrl(endpoint), data, Object.assign({}, this._resolveParams(endpoint)));
            case "PATCH":
                return this.http.patch(this._resolveEndpointUrl(endpoint), data, Object.assign({}, this._resolveParams(endpoint)));
            case "DELETE":
                return this.http.delete(this._resolveEndpointUrl(endpoint), Object.assign({}, this._resolveParams(endpoint)));
            default:
                throw 'o metodo de requeste é inválido - ' + endpoint.method;
        }
    }
    _resolveParams(endpoint) {
        return {
            params: !!endpoint.params ? endpoint.params : {},
            headers: !!endpoint.headers ? endpoint.headers : {},
        };
    }
    _resolveEndpointParamCombine(endpoint1, endpoint2) {
        const result = Object.assign({}, endpoint1);
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.params)) {
            result.params = Object.assign(Object.assign({}, result.params), endpoint2.params);
        }
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.endpoint)) {
            result.endpoint = [
                ...(!!result.endpoint ? result.endpoint : []),
                ...(!!endpoint2.endpoint ? endpoint2.endpoint : [])
            ].filter(filter => !!filter);
        }
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.headers)) {
            result.headers = Object.assign(Object.assign({}, result.headers), endpoint2.headers);
        }
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.context)) {
            result.context = endpoint2.context;
        }
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.path)) {
            result.path = endpoint2.path;
        }
        if (!!(endpoint2 === null || endpoint2 === void 0 ? void 0 : endpoint2.method)) {
            result.method = endpoint2.method;
        }
        return result;
    }
    _resolveEndpointUrl(endpoint) {
        const path = endpoint.path.endsWith('/') ? endpoint.path.substring(0, endpoint.path.length - 1) : endpoint.path;
        let context = endpoint.context.startsWith('/') ? endpoint.context.substring(1) : endpoint.context;
        context = context.endsWith('/') ? context.substring(0, context.length - 1) : context;
        let endpointContext = !!(endpoint === null || endpoint === void 0 ? void 0 : endpoint.endpoint) ? [...endpoint.endpoint] : [];
        let result = path + (!!context ? '/' + context : '');
        if (!!endpointContext) {
            if (Array.isArray(endpointContext)) {
                if (endpointContext.length > 0) {
                    endpointContext = endpointContext.join('/');
                }
                else {
                    return result;
                }
            }
            if (endpointContext.startsWith('/'))
                endpointContext = endpointContext.substring(1);
            if (endpointContext.endsWith('/'))
                endpointContext = endpointContext.substring(endpointContext.length - 1);
            return result + (!!endpointContext ? '/' + endpointContext : '');
        }
        return result;
    }
    /****************************************
     *  METODOS DE VERIFICAÇÃO E CONFIGURAÇÃO
     ***************************************/
    pesquisar(dataId) {
        if (typeof dataId === "number" || typeof dataId === "string") {
            return this.findOne(dataId, '');
        }
        else {
            const findAll = this.endpoints.get('findAll');
            if (!findAll)
                throw 'Endpoint não encontrago';
            //@ts-ignore
            return this.findAll('', dataId);
        }
    }
    saveOrUpdate(data, endpointData) {
        if (data.id) {
            console.log('update');
            return this.update(data, endpointData);
        }
        else {
            console.log('save');
            return this.save(data, endpointData);
        }
    }
    /****************************************
     *  METODOS DE REQUEST DG-CRUD
     ***************************************/
    findAll(endpointUrl, endpointData) {
        const endpoint = this.endpoints.get('findAll');
        if (!endpoint)
            throw 'metodo FindAll não encontrado';
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData));
    }
    findOne(id, endpointData) {
        const endpoint = this.endpoints.get('findOne');
        if (!endpoint)
            throw 'metodo FindOne não encontrado';
        let resultEndpointData = {};
        if (!!endpointData) {
            if (typeof endpointData == 'string') {
                resultEndpointData.endpoint = [endpointData, id];
            }
            else {
                resultEndpointData = Object.assign(Object.assign({}, endpointData), { endpoint: [
                        ...(!!endpointData.endpoint ? endpointData.endpoint : []),
                        id
                    ] });
            }
        }
        else {
            resultEndpointData.endpoint = [id];
        }
        console.log('resultEndpointData', resultEndpointData);
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, resultEndpointData));
        // return this._resolveFetch(data);
    }
    save(data, endpointData) {
        const endpoint = this.endpoints.get('save');
        if (!endpoint)
            throw 'metodo FindAll não encontrado';
        let resultEndpointData = {};
        if (!!endpointData) {
            if (typeof endpointData == 'string') {
                resultEndpointData.endpoint = [endpointData];
            }
            else if (typeof endpointData != 'boolean') {
                resultEndpointData = endpointData;
            }
        }
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, resultEndpointData), data);
    }
    update(data, endpointData) {
        const endpoint = this.endpoints.get('update');
        if (!endpoint)
            throw 'metodo FindAll não encontrado';
        let resultEndpointData = {};
        if (typeof endpointData == 'string') {
            resultEndpointData['endpoint'] = [endpointData];
        }
        else if (typeof endpointData != 'boolean') {
            resultEndpointData = Object.assign({}, endpointData);
        }
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, resultEndpointData), data);
    }
    deleteOne(id, endpointData) {
        const endpoint = this.endpoints.get('deleteOne');
        if (!endpoint)
            throw 'metodo FindAll não encontrado';
        if (!id)
            throw 'você deve informar um id para ser excluído pelo deleteOne';
        let resultEndpointData = {};
        if (!!endpointData) {
            resultEndpointData = Object.assign(Object.assign({}, endpointData), { endpoint: [
                    ...(!!endpointData.endpoint ? endpointData.endpoint : []),
                    id
                ] });
        }
        else {
            resultEndpointData.endpoint = [id];
        }
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, resultEndpointData));
    }
    /****************************************
     *  METODOS DE REQUEST DEFAULT HTTPCLIENT BY PATH/CONTEXT
     ***************************************/
    get(contextFinal, endpointData) {
        const endpoint = {
            path: this._path,
            context: contextFinal,
            method: "GET"
        };
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData));
    }
    post(contextFinal, data, endpointData) {
        const endpoint = {
            path: this._path,
            context: contextFinal,
            method: "POST"
        };
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData), data);
    }
    put(contextFinal, data, endpointData) {
        const endpoint = {
            path: this._path,
            context: contextFinal,
            method: "PUT",
        };
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData), data);
    }
    patch(contextFinal, data, endpointData) {
        const endpoint = {
            path: this._path,
            context: contextFinal,
            method: "PATCH",
        };
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData), data);
    }
    delet(contextFinal, endpointData) {
        const endpoint = {
            path: this._path,
            context: contextFinal,
            method: "DELETE"
        };
        return this._resolveFetch(this._resolveEndpointParamCombine(endpoint, endpointData));
    }
    /****************************************
     *  METODO DE AGRUPAMENTO DOS METODOS DE REQUEST DEFAULT HTTPCLIENT
     *  COM O CONTEXT LIMPO
     ***************************************/
    cleanContext() {
        let endpoint = {
            path: this._path,
            context: '',
            method: "GET",
        };
        return {
            get: (partialUrl, endpointData) => {
                endpoint = Object.assign(Object.assign(Object.assign({}, endpoint), { endpoint: [partialUrl] }), endpointData);
                return this._resolveFetch(endpoint);
            },
            post: (partialUrl, endpointData) => {
                endpoint = Object.assign(Object.assign(Object.assign(Object.assign({}, endpoint), { endpoint: [partialUrl] }), endpointData), { method: 'POST' });
                return this._resolveFetch(endpoint);
            },
            put: (partialUrl, endpointData) => {
                endpoint = Object.assign(Object.assign(Object.assign(Object.assign({}, endpoint), { endpoint: [partialUrl] }), endpointData), { method: 'PUT' });
                return this._resolveFetch(endpoint);
            },
            delete: (partialUrl, endpointData) => {
                endpoint = Object.assign(Object.assign(Object.assign(Object.assign({}, endpoint), { endpoint: [partialUrl] }), endpointData), { method: 'DELETE' });
                return this._resolveFetch(endpoint);
            },
        };
    }
    /****************************************
     *  METODOS DEPRECATE
     ***************************************/
    /**
     * @deprecated
     * Esse metodo era usado quando o service fazia um controle central
     * do PATH. com a migração para o controle dinâmico de endpoints,
     * esse deverá ser descontinuado
     */
    alterResource(resource) {
        [...this.endpoints.keys()].map((keyEndpoint) => {
            this.editEndpoint(keyEndpoint, { context: resource });
        });
    }
    /**
     * @deprecated
     * Esse metodo era usado quando o service fazia um controle central
     * do PATH. com a migração para o controle dinâmico de endpoints,
     * esse deverá ser descontinuado.
     *
     * Obs: Por retrocompatibilidade, assumiremos esse parametro
     * para o fluxo 'findAll'
     *
     * @addParams('nomeDoFluxo').setParams({})
     * para adicionar parametros diretamente en um fluxo desejado
     */
    addWhere(where) {
        this.addParams('findAll', where);
    }
    /**
     * @deprecated
     * Esse metodo era usado quando o service fazia um controle central
     * do PATH. com a migração para o controle dinâmico de endpoints,
     * esse deverá ser descontinuado.
     *
     * Obs: Por retrocompatibilidade, assumiremos essa remoção de
     * parametro para o fluxo 'findAll'
     *
     * @addParams('nomeDoFluxo').removeParams([])
     * para adicionar parametros diretamente en um fluxo desejado
     */
    removeWhere(where) {
        this.removeParams('findAll', where);
    }
    /**
     * @deprecated
     *
     * @param id
     * @param ids
     * @param endpoint
     */
    delete(id, ids, endpoint) {
        const data = {};
        if (!!endpoint) {
            data.endpoint = [endpoint];
        }
        return this.deleteOne(id, data);
    }
    /**
     * @deprecated
     */
    dictionaryFindAll(data) {
        if (!this.dictionary.findAll) {
            return data;
        }
        return data.map((dat) => {
            if (typeof this.dictionary.findAll == 'object') {
                return this._transpileDictionaryObject(dat, this.dictionary.findAll);
            }
            else if (typeof this.dictionary.findAll == 'function') {
                return this.dictionary.findAll(dat);
            }
        });
    }
    /**
     * @deprecated
     * @param data
     * @param method
     */
    dictionaryOne(data, method) {
        if (!this.dictionary.findOne) {
            return data;
        }
        if (typeof this.dictionary.findOne == 'object') {
            return this._transpileDictionaryObject(data, this.dictionary.findOne);
        }
        else if (typeof this.dictionary.findOne == 'function') {
            return this.dictionary.findOne(data);
        }
        return data;
    }
    /**
     * @deprecated
     */
    _transpileDictionaryObject(data, dictionary) {
        Object.keys(dictionary).map((dictio) => {
            // @ts-ignore
            const field = dictionary[dictio];
            if (typeof field == 'string') {
                if (field in data) {
                    // @ts-ignore
                    data[dictio] = data[field];
                    // @ts-ignore
                    delete data[field];
                }
            }
            else if (Array.isArray(field)) {
                // @ts-ignore
                data[dictio] = data;
                field.map((nivelArray) => {
                    // @ts-ignore
                    if (!!data[dictio]) {
                        // @ts-ignore
                        if (nivelArray in data[dictio]) {
                            // @ts-ignore
                            data[dictio] = data[dictio][nivelArray];
                        }
                        else {
                            // @ts-ignore
                            data[dictio] = null;
                        }
                    }
                });
            }
        });
        return data;
    }
}

function clearEntity(entity) {
    if (entity instanceof AbstractEntity) {
        const { setPagination, addColumns, removeColumns, configEntityTable, serviceAction, addFilters, addActions, addTableParams, removeFilters, dataServer } = entity, saveData = __rest(entity, ["setPagination", "addColumns", "removeColumns", "configEntityTable", "serviceAction", "addFilters", "addActions", "addTableParams", "removeFilters", "dataServer"]);
        return saveData;
    }
    const { dataServer } = entity, saveData = __rest(entity, ["dataServer"]);
    return saveData;
}

class CrudHttpService extends AbstractHttpService {
    constructor(Http) {
        super(Http, '', '');
        this.Http = Http;
    }
}
CrudHttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHttpService, deps: [{ token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CrudHttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHttpService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHttpService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }]; } });

class InsertEditConfig {
    constructor(generic, location) {
        this.generic = generic;
        this.location = location;
    }
}
InsertEditConfig.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig, deps: [{ token: CrudHttpService }, { token: i1.Location }], target: i0.ɵɵFactoryTarget.Injectable });
InsertEditConfig.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CrudHttpService }, { type: i1.Location }]; } });

class AbstractInsertEdit {
    constructor(_config, 
    // protected crudService: AbstractHttpService<ENTITY>,
    _crudService) {
        this.crudConfig = {
            backAfterSave: true,
            backAfterFetchError: true,
            subscribeEntityAfterSave: true,
        };
        this.callbackMessages = {
            errorFetch: {
                showMessage: true
            },
            successSave: {
                showMessage: true,
                title: 'Novo registro salvo',
                text: 'O novo registro foi salvo com sucesso',
                confirmButtonText: 'Fechar',
                customClass: '',
                timer: 3000
            },
            successUpdate: {
                showMessage: true,
                title: 'Alterações salvas',
                text: 'As alterações realizadas foram salvas com sucesso',
                confirmButtonText: 'Fechar',
                customClass: '',
                timer: 3000
            },
            errorAfterSave: {
                showMessage: true,
                title: 'Preencha os campos obrigatórios',
                text: 'Um ou mais campos não foram preenchidos corretamente.',
                confirmButtonText: 'Fechar',
                timer: 5000,
                customClass: ''
            },
            errorFetchEntity: {
                showMessage: true,
                title: 'Não foi possível achar o registro',
                text: 'Recarrege a página ou volte a tela anterior',
                confirmButtonText: 'Recarregar',
                showCancelButton: true,
                cancelButtonText: 'Voltar',
                allowOutsideClick: false
            },
            successDelete: {
                showMessage: true,
                title: 'Removido com sucesso!',
                text: 'Este registro foi excluído.'
            },
        };
        if (!_config) {
            throw 'ConfigDgCrudService não informado';
        }
        if (!!_crudService) {
            if (_crudService instanceof AbstractHttpService) {
                this.crudService = _crudService;
            }
            else {
                if (_config instanceof InsertEditConfig) {
                    this.crudService = _config.generic;
                    this.crudService.editEndpointAll({ path: _crudService.path, context: _crudService.context });
                }
                else {
                    throw 'Para usar o service nativo da DG_CRUD altere o config da class de "AbstractConfigDgCrudService" para ' +
                        'InsertEditConfig fornecido pela própria DG_CRUD';
                }
            }
        }
        else {
        }
        this.location = _config.location;
    }
    ngOnInit() {
        this.getIdFromRoute();
    }
    getIdFromRoute() {
        const idUrl = window.location.href.split('/')[window.location.href.split('/').length - 1];
        this.entityId = null;
        if (idUrl === 'novo' || idUrl === 'Novo') {
            this.initNewEntity();
        }
        else if (idUrl.trim() !== '' || !!Number(idUrl)) {
            this.entityId = idUrl;
            this.fetchEntity(this.entityId);
        }
        else {
            this.location.back();
        }
    }
    fetchEntity(id) {
        if (id) {
            this.crudService.pesquisar(id).subscribe((response) => {
                // @ts-ignore
                this.entity = this.crudService.dictionaryOne(response.data || response);
                this.afterFetchEntity();
            }, error => {
                console.error("dg-crug: ", error);
                if (this.callbackMessages.errorFetchEntity.showMessage) {
                    this.msgErrorFetchEntity();
                }
                else {
                    if (this.crudConfig.backAfterFetchError) {
                        this.location.back();
                    }
                }
            });
        }
    }
    afterFetchEntity() {
    }
    voltar() {
        this.location.back();
    }
    deletar() {
        Swal.fire({
            title: 'Excluir registro',
            text: "Deseja excluir este registro? Esta ação é permanente.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Excluir'
        }).then((result) => {
            if (result.isConfirmed) {
                this.crudService.deleteOne(this.entity.id)
                    .subscribe(() => {
                    this.msgSuccessDelete();
                }, error => {
                    console.log(error);
                }, () => this.voltar());
            }
        });
    }
    salvar(endpoint = '') {
        const paramSave = this.checkDataEvents(endpoint);
        const canSave = this.beforeSaveEntity();
        if (!canSave) {
            this.msgErrorAfterSaveEntity();
        }
        else {
            const saveData = clearEntity(this.entity);
            const saveMethod = saveOrUpdate(saveData, 'id');
            //@ts-ignore
            this.crudService.saveOrUpdate(saveData, paramSave.endPoint)
                .subscribe(response => {
                if (this.crudConfig.subscribeEntityAfterSave || (paramSave.backAfterSave && !this.entity.id)) {
                    // @ts-ignore
                    this.entity = response.data;
                }
                this.afterSaveEntity();
                if (saveMethod == 'save') {
                    this.msgSuccessSaveEntity();
                }
                else {
                    this.msgSuccessUpdateEntity();
                }
            }, () => {
                this.afterErrorSave();
            }, () => {
                if (paramSave.backAfterSave != undefined) {
                    if (paramSave.backAfterSave) {
                        this.voltar();
                    }
                }
                else if (this.crudConfig.backAfterSave) {
                    this.voltar();
                }
            });
        }
    }
    beforeSaveEntity() {
        return true;
    }
    afterSaveEntity() {
    }
    checkDataEvents(data) {
        if (typeof data === "string") {
            return {
                endPoint: data,
                backAfterSave: undefined
            };
        }
        let result = {
            endPoint: false,
            backAfterSave: undefined
        };
        if (data instanceof CustomEvent) {
            if (data.detail) {
                if (typeof data.detail.endPoint === 'string') {
                    result.endPoint = data.detail.endPoint;
                }
                if (typeof data.detail.backAfterSave === 'boolean') {
                    result.backAfterSave = data.detail.backAfterSave;
                }
            }
        }
        if (data instanceof Object) {
            if ('endPoint' in data || 'backAfterSave' in data) {
                if ('endPoint' in data) {
                    if (typeof data.endPoint === 'string') {
                        result.endPoint = data.endPoint;
                    }
                }
                if ('backAfterSave' in data) {
                    if (typeof data.backAfterSave === 'boolean') {
                        result.backAfterSave = data.backAfterSave;
                    }
                }
            }
        }
        return result;
    }
    // MENSAGENS DE RETORNO
    msgSuccessSaveEntity() {
        const _a = this.callbackMessages.successSave, { showMessage, customClass } = _a, rest = __rest(_a, ["showMessage", "customClass"]);
        Swal.fire(Object.assign({ icon: (rest === null || rest === void 0 ? void 0 : rest.icon) || 'success', customClass: 'callback-dg-crud error-success-save ' + (!!customClass ? customClass : '') }, rest)).then();
    }
    msgSuccessUpdateEntity() {
        const _a = this.callbackMessages.successUpdate, { showMessage, customClass } = _a, rest = __rest(_a, ["showMessage", "customClass"]);
        Swal.fire(Object.assign({ icon: (rest === null || rest === void 0 ? void 0 : rest.icon) || 'success', customClass: 'callback-dg-crud error-success-update ' + (!!customClass ? customClass : '') }, rest)).then();
    }
    msgErrorAfterSaveEntity() {
        const _a = this.callbackMessages.errorAfterSave, { showMessage, customClass } = _a, rest = __rest(_a, ["showMessage", "customClass"]);
        Swal.fire(Object.assign({ icon: (rest === null || rest === void 0 ? void 0 : rest.icon) || 'warning', customClass: 'callback-dg-crud error-after-fetch-entity ' + (!!customClass ? customClass : '') }, rest)).then();
    }
    msgSuccessDelete() {
        const _a = this.callbackMessages.successDelete, { showMessage, customClass } = _a, rest = __rest(_a, ["showMessage", "customClass"]);
        Swal.fire(Object.assign({ icon: (rest === null || rest === void 0 ? void 0 : rest.icon) || 'success', customClass: 'callback-dg-crud error-success-update ' + (!!customClass ? customClass : '') }, rest)).then();
    }
    msgErrorFetchEntity() {
        const _a = this.callbackMessages.errorFetchEntity, { showMessage, customClass } = _a, rest = __rest(_a, ["showMessage", "customClass"]);
        Swal.fire(Object.assign({ icon: (rest === null || rest === void 0 ? void 0 : rest.icon) || 'error', customClass: 'callback-dg-crud error-fetch-entity ' + (!!customClass ? customClass : '') }, rest)).then(e => {
            if (e.isConfirmed) {
                window.location.reload();
            }
            else {
                this.voltar();
            }
        });
    }
    // SAÍDAS DE ERRO
    afterErrorSave() { }
}
AbstractInsertEdit.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AbstractInsertEdit, deps: [{ token: InsertEditConfig }, { token: undefined }], target: i0.ɵɵFactoryTarget.Component });
AbstractInsertEdit.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AbstractInsertEdit, selector: "ng-component", host: { listeners: { "window:voltar-insert-edit-event": "voltar($event)", "window:deletar-insert-edit-event": "deletar($event)", "window:salvar-insert-edit-event": "salvar($event)" } }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AbstractInsertEdit, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [InsertEditConfig]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [undefined]
                }] }]; }, propDecorators: { voltar: [{
                type: HostListener,
                args: ['window:voltar-insert-edit-event', ['$event']]
            }], deletar: [{
                type: HostListener,
                args: ['window:deletar-insert-edit-event', ['$event']]
            }], salvar: [{
                type: HostListener,
                args: ['window:salvar-insert-edit-event', ['$event']]
            }] } });

class AbstractConfigDgCrudService {
    constructor(http = HttpClient, location = Location) {
        this.http = http;
        this.location = location;
    }
}

/**
 * Decorator. funciona como uma infercace de transição dos dados
 * para entrada de funções da tabela
 * @param value
 * @constructor
 */
function DgActionsTable(value) {
    //@ts-ignore
    return (constructor) => {
        return class extends constructor {
            constructor() {
                super(...arguments);
                this.serviceAction = value;
            }
        };
    };
}

/**
 * Esse Decorator serve para criar services dinâmicos, a partir da entidade.
 * Seu uso foi pensado para services com pouca ou nenhuma alteração do padrão.
 * Com isso espero diminuir os codigos criados apenas para integração do fluxo obritório da dg-crud
 */
function DataServer(data) {
    //@ts-ignore
    return (constructor) => {
        return class extends constructor {
            constructor() {
                super(...arguments);
                this.dataServer = data;
            }
        };
    };
}

/**
 *  Decorator. funciona como uma infercace de transição dos dados
 * @param data
 * @constructor
 */
function DgTableColumn(data) {
    return function (target, propertyKey) {
        let properties = Reflect.getMetadata(tableColumnKey, target);
        if (!properties) {
            properties = new Map();
        }
        const tableColumn = new DgTableColumnClass({
            columnName: (data.columnName ? data.columnName : propertyKey),
            resource: data.resource,
            mask: data.mask,
            columnClassName: data.columnClassName,
            width: data.width,
            fixedColumnEnd: !!data.fixedColumnEnd,
            fixedColumnStart: !!data.fixedColumnStart,
            declaratResourceMethod: data.declaratResourceMethod,
            sort: !!data.sort
        });
        properties.set(propertyKey, tableColumn);
        Reflect.defineMetadata(tableColumnKey, properties, target);
    };
}

/**
 * DECORATOR usado para criação de inputs basicos
 * @param type
 * @param data
 * @constructor
 */
function DgFilter_input(type = 'text', data) {
    return function (target, propertyKey) {
        let properties = Reflect.getMetadata(filterFieldKey, target);
        if (!properties) {
            properties = new Map();
        }
        const tableColumn = new DgFilterFieldClass(type, data === null || data === void 0 ? void 0 : data.name, data === null || data === void 0 ? void 0 : data.colum, undefined, data === null || data === void 0 ? void 0 : data.mask, undefined, undefined, undefined, data === null || data === void 0 ? void 0 : data.placeholder, data === null || data === void 0 ? void 0 : data.defaultData, undefined, undefined, data === null || data === void 0 ? void 0 : data.required, data === null || data === void 0 ? void 0 : data.position, undefined, undefined, data === null || data === void 0 ? void 0 : data.nameParamFind, undefined, data === null || data === void 0 ? void 0 : data.outputFormat);
        properties.set(propertyKey, tableColumn);
        Reflect.defineMetadata(filterFieldKey, properties, target);
    };
}

/**
 * DECORATOR usado para criação de selects
 * @param data
 * @constructor
 */
function DgFilter_select(data) {
    return function (target, propertyKey) {
        let properties = Reflect.getMetadata(filterFieldKey, target);
        if (!properties) {
            properties = new Map();
        }
        const tableColumn = new DgFilterFieldClass('select', data === null || data === void 0 ? void 0 : data.name, data === null || data === void 0 ? void 0 : data.colum, undefined, data === null || data === void 0 ? void 0 : data.mask, undefined, undefined, data === null || data === void 0 ? void 0 : data.data, data === null || data === void 0 ? void 0 : data.placeholder, data === null || data === void 0 ? void 0 : data.defaultData, data === null || data === void 0 ? void 0 : data.propertValue, undefined, data === null || data === void 0 ? void 0 : data.required, data === null || data === void 0 ? void 0 : data.position, data === null || data === void 0 ? void 0 : data.propertKey, data === null || data === void 0 ? void 0 : data.nameParamFilter, data === null || data === void 0 ? void 0 : data.nameParamFind, undefined, data === null || data === void 0 ? void 0 : data.outputFormat);
        properties.set(propertyKey, tableColumn);
        Reflect.defineMetadata(filterFieldKey, properties, target);
    };
}

/**
 * DECORATOR usado para criação de auto-completes
 * @param data
 * @param serverData
 * @constructor
 */
function DgFilter_autoComplete(data, serverData) {
    return function (target, propertyKey) {
        let properties = Reflect.getMetadata(filterFieldKey, target);
        if (!properties) {
            properties = new Map();
        }
        const tableColumn = new DgFilterFieldClass('autoComplete', data === null || data === void 0 ? void 0 : data.name, data === null || data === void 0 ? void 0 : data.colum, undefined, //data?.resource,
        data === null || data === void 0 ? void 0 : data.mask, undefined, //data?.declaratResourceMethod,
        serverData === null || serverData === void 0 ? void 0 : serverData.getUrl, data === null || data === void 0 ? void 0 : data.data, data === null || data === void 0 ? void 0 : data.placeholder, data === null || data === void 0 ? void 0 : data.defaultData, serverData === null || serverData === void 0 ? void 0 : serverData.propertValue, serverData === null || serverData === void 0 ? void 0 : serverData.getServerData, data === null || data === void 0 ? void 0 : data.required, data === null || data === void 0 ? void 0 : data.position, serverData === null || serverData === void 0 ? void 0 : serverData.propertKey, serverData === null || serverData === void 0 ? void 0 : serverData.nameParamFilter, serverData === null || serverData === void 0 ? void 0 : serverData.nameParamFind, serverData === null || serverData === void 0 ? void 0 : serverData.inputFormat, serverData === null || serverData === void 0 ? void 0 : serverData.outputFormat, serverData === null || serverData === void 0 ? void 0 : serverData.params);
        properties.set(propertyKey, tableColumn);
        Reflect.defineMetadata(filterFieldKey, properties, target);
    };
}

function crudDispatchEvent(tableEventId) {
    window.dispatchEvent(new CustomEvent('dg-table-atualizar-event', { detail: tableEventId }));
}

var CdkAbstractService;
(function (CdkAbstractService) {
    function resolveEndpointUrl(val) {
        val = val.map(v => {
            if (!!v) {
                v = String(v).endsWith('/') ? String(v).substring(0, String(v).length - 1) : v;
                v = String(v).startsWith('/') ? String(v).substring(1) : v;
                return v;
            }
            return null;
        }).filter(v => !!v);
        return val.join('/');
    }
    CdkAbstractService.resolveEndpointUrl = resolveEndpointUrl;
    function saveOrUpdate(data, identificador) {
        if (typeof data == 'object') {
            if (identificador in data) {
                if (!!data[identificador]) {
                    return 'update';
                }
            }
        }
        if (data instanceof FormData) {
            if (!!data.get(identificador)) {
                return 'update';
            }
        }
        return 'save';
    }
    CdkAbstractService.saveOrUpdate = saveOrUpdate;
    /**
     * metodo para resolver tratamento de parametros para o envio
     * @param endpoint
     */
    function resolveParams(endpoint) {
        return {
            params: !!endpoint.params ? endpoint.params : {},
            headers: !!endpoint.headers ? endpoint.headers : {},
        };
    }
    CdkAbstractService.resolveParams = resolveParams;
})(CdkAbstractService || (CdkAbstractService = {}));

class AbstractHttpService2 {
    constructor(_http, _path = '', context = '') {
        this._http = _http;
        this._path = _path;
        this.context = context;
        this.pipes = {
            findOne: (e) => e,
            save: undefined,
            update: undefined,
        };
        this.alternativeContext = {
            findOne: undefined,
            save: undefined,
            update: undefined,
            deleteOne: undefined,
        };
    }
    //######################################
    // metodos de controle
    //######################################
    tapPipe(namePipe, val) {
        if (!!this.pipes[namePipe]) {
            // @ts-ignore
            return this.pipes[namePipe](val);
        }
        return val;
    }
    resolveContextFinal(context) {
        const contextFinal = [this._path];
        if (!!context) {
            contextFinal.push(context);
        }
        else if ('findOne' in this.alternativeContext) {
            if (typeof this.alternativeContext.findOne == 'string') {
                contextFinal.push(this.alternativeContext['findOne']);
            }
            else {
                contextFinal.push(this.context);
            }
        }
        else {
            contextFinal.push(this.context);
        }
        return contextFinal;
    }
    registerPipe(namePipe, pipe) {
        this.pipes[namePipe] = pipe;
    }
    changePath(path) {
        this._path = path;
    }
    changeContext(context) {
        this.context = context;
    }
    registerAlternativeContext(fatchName, context) {
        this.alternativeContext[fatchName] = context;
    }
    //######################################
    // metodos FETCH
    //######################################
    findOne(contextFinal, options) {
        const context = this.resolveContextFinal(contextFinal);
        if (options === null || options === void 0 ? void 0 : options.params) {
            if (typeof options.params == 'number' || typeof options.params == 'string') {
                context.push(options.params);
                options.params = {};
            }
        }
        return this._http.get(CdkAbstractService.resolveEndpointUrl(context), options).pipe(tap((resp) => this.tapPipe('findOne', resp)));
    }
    save(data, options) {
        const context = [this._path, this.context];
        return this._http.post(CdkAbstractService.resolveEndpointUrl(context), data, options).pipe(tap((resp) => this.tapPipe('save', resp)));
    }
    update(data, options) {
        const context = [this._path, this.context];
        return this._http.post(CdkAbstractService.resolveEndpointUrl(context), data, options).pipe(tap((resp) => this.tapPipe('update', resp)));
    }
}

class CrudHtt2Service extends AbstractHttpService2 {
    constructor(Http) {
        super(Http, '', '');
        this.Http = Http;
    }
}
CrudHtt2Service.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHtt2Service, deps: [{ token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CrudHtt2Service.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHtt2Service, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: CrudHtt2Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }]; } });

class InsertEditConfig2 {
    constructor(generic, location) {
        this.generic = generic;
        this.location = location;
    }
}
InsertEditConfig2.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig2, deps: [{ token: CrudHtt2Service }, { token: i1.Location }], target: i0.ɵɵFactoryTarget.Injectable });
InsertEditConfig2.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig2, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: InsertEditConfig2, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CrudHtt2Service }, { type: i1.Location }]; } });

var CdkAbstractInsertEdit;
(function (CdkAbstractInsertEdit) {
    /**
     * função dedicada a receber os parametros do metodo de findOne
     */
    function checkDataEvents(data, config) {
        if (typeof data === "string") {
            return {
                endPoint: data,
                backAfterSave: config.backAfterSave
            };
        }
        let result = {
            endPoint: '',
            backAfterSave: config.backAfterSave
        };
        if (data instanceof CustomEvent) {
            if (data.detail) {
                if (typeof data.detail.endPoint === 'string') {
                    result.endPoint = data.detail.endPoint;
                }
                if (typeof data.detail.backAfterSave === 'boolean') {
                    result.backAfterSave = data.detail.backAfterSave;
                }
            }
        }
        if (data instanceof Object) {
            if ('endPoint' in data || 'backAfterSave' in data) {
                if ('endPoint' in data) {
                    if (typeof data.endPoint === 'string') {
                        result.endPoint = data.endPoint;
                    }
                }
                if ('backAfterSave' in data) {
                    if (typeof data.backAfterSave === 'boolean') {
                        result.backAfterSave = data.backAfterSave;
                    }
                }
            }
        }
        return result;
    }
    CdkAbstractInsertEdit.checkDataEvents = checkDataEvents;
    /**
     * Classe dedicada a realizar a ENTRADA de configurações.
     * Essa classe irá reunir todos as configurações possíveis solicitadas
     * ao longo do clico de vida do AbstractInsertEdit2, incluindo as configurações
     * solicitadas para criação do rootService<AbstractHttpService2>.
     */
    class setRootConfig {
    }
    CdkAbstractInsertEdit.setRootConfig = setRootConfig;
    /**
     *  Classe de configurações do AbstractInsertEdit2
     *  Essa classe contem apenas valores necessários para
     *  as configurações da classe "AbstractInsertEdit2", os demais
     *  valores importados em "setRootConfig" ficarão armazenados nas
     *  suas respectivas classes.
     */
    class RootConfigInsertEdit {
        constructor() {
            this.subscribeEntityAfterSave = true;
            this.backAfterSave = true;
        }
    }
    CdkAbstractInsertEdit.RootConfigInsertEdit = RootConfigInsertEdit;
})(CdkAbstractInsertEdit || (CdkAbstractInsertEdit = {}));

class AbstractInsertEdit2 {
    constructor(_config, config) {
        this.rootConfig = new CdkAbstractInsertEdit.RootConfigInsertEdit();
        this.rootService = _config.generic;
        this.location = _config.location;
        if (!!config) {
            this.setRootConfig(config);
        }
    }
    //######################################
    // metodos estrategicos para override
    //######################################
    find(params, context = '') {
        return this.rootService.findOne(context, { params });
    }
    save(data, context = '') {
        return this.rootService.save(data);
    }
    update(data, context = '') {
        return this.rootService.save(data);
    }
    initNewEntity() {
    }
    ;
    afterFetchEntity(entityData) {
    }
    beforeSaveEntity() {
        return true;
    }
    afterSaveEntity(entityData) {
    }
    setRootConfig(config) {
        if (config.path)
            this.rootService.changePath(config.path);
        if (config.context)
            this.rootService.changePath(config.context);
        if ('backAfterSave' in config)
            this.rootConfig.backAfterSave = !!config['backAfterSave'];
        if ('subscribeEntityAfterSave' in config)
            this.rootConfig.backAfterSave = !!config['subscribeEntityAfterSave'];
        if (!!(config === null || config === void 0 ? void 0 : config.alternativeContext)) {
            if ('findOne' in (config === null || config === void 0 ? void 0 : config.alternativeContext)) {
                this.rootService.registerAlternativeContext('findOne', config === null || config === void 0 ? void 0 : config.alternativeContext['findOne']);
            }
            if ('save' in (config === null || config === void 0 ? void 0 : config.alternativeContext)) {
                this.rootService.registerAlternativeContext('save', config === null || config === void 0 ? void 0 : config.alternativeContext['save']);
            }
            if ('update' in (config === null || config === void 0 ? void 0 : config.alternativeContext)) {
                this.rootService.registerAlternativeContext('update', config === null || config === void 0 ? void 0 : config.alternativeContext['update']);
            }
            if ('deleteOne' in (config === null || config === void 0 ? void 0 : config.alternativeContext)) {
                this.rootService.registerAlternativeContext('deleteOne', config === null || config === void 0 ? void 0 : config.alternativeContext['deleteOne']);
            }
        }
    }
    ngOnInit() {
        var _a, _b, _c, _d;
        if (!!((_b = (_a = this === null || this === void 0 ? void 0 : this.rootEntity) === null || _a === void 0 ? void 0 : _a.dataServer) === null || _b === void 0 ? void 0 : _b.path)) {
            this.rootService.changePath(this.rootEntity.dataServer.path);
        }
        if (!!((_d = (_c = this === null || this === void 0 ? void 0 : this.rootEntity) === null || _c === void 0 ? void 0 : _c.dataServer) === null || _d === void 0 ? void 0 : _d.context)) {
            this.rootService.changeContext(this.rootEntity.dataServer.context);
        }
        this.getIdFromRoute();
    }
    /**
     * Metodo responsável por identificar o id, caso encontre a palavra "novo"
     * irá compreender que se trata de um novo registro.
     * Esse método deve chamar os metodos initNewEntity() ou fetchEntity(this.entityId)
     * em casos de "novo" ou "edição" respectivamente
     */
    getIdFromRoute() {
        const idUrl = window.location.href.split('/')[window.location.href.split('/').length - 1];
        this.entityId = null;
        if (idUrl === 'novo' || idUrl === 'Novo') {
            this.entity = clearEntity(this.rootEntity);
            this.initNewEntity();
        }
        else if (idUrl.trim() !== '' || !!Number(idUrl)) {
            this.entityId = idUrl;
            this.fetchEntity(this.entityId);
        }
        else {
            this.location.back();
        }
    }
    // TODO resolver apresentação de mensagens
    fetchEntity(params) {
        if (!!params) {
            if (typeof params == "number" || typeof params == "string") {
                params = { id: params };
            }
            this.find(params).subscribe((response) => {
                this.entity = response.data;
                this.afterFetchEntity(this.entity);
            }, error => {
                console.error("dg-crug: ", error);
                // if (this.callbackMessages.errorFetchEntity.showMessage) {
                //   this.msgErrorFetchEntity();
                // } else {
                //   if (this.crudConfig.backAfterFetchError) {
                //     this.location.back();
                // }
                // }
            });
        }
    }
    //######################################
    // metodos conectados a eventos do ciclo de vida
    //######################################
    // TODO resolver apresentação de mensagens
    salvar(endpoint = '') {
        const paramSave = CdkAbstractInsertEdit.checkDataEvents(endpoint, this.rootConfig);
        const canSave = this.beforeSaveEntity();
        if (!canSave) {
            // this.msgErrorAfterSaveEntity();
            alert('preencha todos os campos');
        }
        else {
            const saveMethod = CdkAbstractService.saveOrUpdate(this.entity, 'id');
            this[saveMethod](this.entity, paramSave.endPoint || '').subscribe({
                next: (response) => {
                    if (this.rootConfig.subscribeEntityAfterSave || (paramSave.backAfterSave && !this.entity.id)) {
                        // @ts-ignore
                        this.entity = response.data;
                    }
                    this.afterSaveEntity(response.data);
                    if (saveMethod == 'save') {
                        // this.msgSuccessSaveEntity()
                        alert('save');
                    }
                    else {
                        // this.msgSuccessUpdateEntity()
                        alert('update');
                    }
                },
                error: (error) => {
                    console.error(error);
                },
                complete: () => {
                    if (paramSave.backAfterSave) {
                        this.voltar();
                    }
                }
            });
        }
    }
    voltar() {
        this.location.back();
    }
    // TODO resolver apresentação de mensagens
    deletar() {
        alert('aguardando implementação');
        // Swal.fire({
        //   title: 'Excluir registro',
        //   text: "Deseja excluir este registro? Esta ação é permanente.",
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#d33',
        //   cancelButtonColor: '#3085d6',
        //   cancelButtonText: 'Cancelar',
        //   confirmButtonText: 'Excluir'
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     this.rootService.deleteOne(this.entity.id)
        //       .subscribe({
        //         next: () => {
        //           // this.msgSuccessDelete()
        //         },
        //         error: (error) => {
        //           console.error(error);
        //         },
        //         complete: () => this.voltar()
        //       });
        //   }
        // })
    }
}
AbstractInsertEdit2.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AbstractInsertEdit2, deps: [{ token: InsertEditConfig2 }, { token: CdkAbstractInsertEdit.setRootConfig }], target: i0.ɵɵFactoryTarget.Component });
AbstractInsertEdit2.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: AbstractInsertEdit2, selector: "ng-component", host: { listeners: { "window:salvar-insert-edit-event": "salvar($event)", "window:voltar-insert-edit-event": "voltar($event)", "window:deletar-insert-edit-event": "deletar($event)" } }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: AbstractInsertEdit2, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: InsertEditConfig2, decorators: [{
                    type: Inject,
                    args: [InsertEditConfig2]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CdkAbstractInsertEdit.setRootConfig]
                }] }]; }, propDecorators: { salvar: [{
                type: HostListener,
                args: ['window:salvar-insert-edit-event', ['$event']]
            }], voltar: [{
                type: HostListener,
                args: ['window:voltar-insert-edit-event', ['$event']]
            }], deletar: [{
                type: HostListener,
                args: ['window:deletar-insert-edit-event', ['$event']]
            }] } });

class AbstractRoot2Entity {
}

class AbstractEntity2 extends AbstractRoot2Entity {
}

/*
 * Public API Surface of dg-crud
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractActionsTableService, AbstractConfigDgCrudService, AbstractEntity, AbstractEntity2, AbstractHttpService, AbstractHttpService2, AbstractInsertEdit, AbstractInsertEdit2, AbstractRoot2Entity, AbstractRootEntity, AdicionarDirective, CdkAbstractInsertEdit, ClearDirective, CrudDataTableComponent, CrudFiltersComponent, CrudHtt2Service, CrudPaginationComponent, CrudTableArrayComponent, DataServer, DeletarDirective, DgActionsTable, DgCrudModule, DgDataTableComponent, DgFilter_autoComplete, DgFilter_input, DgFilter_select, DgTableColumn, DgTableColumnClass, FindFiltersDirective, InsertEditConfig, InsertEditConfig2, RegisterCrudTableService, SalvarDirective, VoltarDirective, clearEntity, crudDispatchEvent, tableColumnKey };
